// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:40.228Z
// Property: Newport Amarillo Apts (ID: 6767906449165613)
// Collections: 24 amenities, 7 floorplans (live), 36 photos, 67 POIs, 1 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165613",
  "property_external_id": "fv85zds",
  "property_zillow_url": "https://www.zillow.com/homedetails/6100-SW-45th-Ave-Amarillo-TX-79109/202217845_zpid/",
  "property_apartments_url": "https://www.apartments.com/newport-amarillo-apts-amarillo-tx/fv85zds/",
  "property_google_business_url": "https://www.google.com/maps/place/Newport+Apartments/data=!4m2!3m1!1s0x0:0x59c608f0f01289ed?sa=X&ved=2ahUKEwiEn-Tb-7ySAxVhM0QIHXrIH_oQ_BJ6BAhFEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "newport-amarillo-apts",
  "property_name": "Newport Amarillo Apts",
  "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/newport/",
  "property_domain": null,
  "property_address": "6100 Southwest 45th",
  "property_full_address": "6100 Southwest 45th, Amarillo, TX, 79109",
  "property_address_1": "6100 Southwest 45th",
  "property_address_2": null,
  "property_address_city": "Amarillo",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79109",
  "property_address_country": "US",
  "property_address_county": "Potter County",
  "property_neighborhood_address": "Amarillo",
  "property_address_latitude": "35.1624",
  "property_address_longitude": "-101.904",
  "property_email": "newportamarillo@caseusa.com",
  "property_phone": "(806) 304-7189",
  "property_call_tracking_phone": "833-705-2201",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Newport Amarillo Apts, where comfort meets convenience in the heart of Amarillo, Texas. Choose from spacious one or two-bedroom floor plans, and enjoy exceptional amenities including a shimmering pool, dog park, and inviting clubhouse. Schedule your tour today and envision your perfect home! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Newport Amarillo Apartments - Your Ideal Home Awaits!**\n\nLocated in the heart of Amarillo, Texas, Newport Amarillo Apartments offers the perfect blend of comfort, convenience, and community living. Choose from our thoughtfully designed one and two-bedroom floor plans, crafted to meet your lifestyle needs. With spacious layouts and modern amenities, you'll feel right at home from day one.\n\nOur vibrant community features an array of fantastic amenities to elevate your living experience. Dive into relaxation at our sparkling pool, or host memorable gatherings in the inviting clubhouse and picnic area, complete with grills. Enjoy outdoor activities? Make the most of our basketball court, sundeck, and beautifully landscaped courtyard, perfect for leisurely strolls and playtime with your furry friends at the onsite dog park.\n\nAt Newport Amarillo, we prioritize your comfort and convenience. Our professional management team and onsite maintenance are always available to assist you, ensuring a stress-free living environment. Enjoy the convenience of laundry facilities, ample storage space, and high-speed internet access, along with in-home features such as air conditioning, ceiling fans, dishwashers, and cozy fireplaces.\n\nExperience the best of apartment living at Newport Amarillo Apartments. With the perfect mix of relaxation, recreation, and community spirit, you’ll find everything you need right at your doorstep. Don’t miss out—find your new home today! Browse our availability or schedule a tour to visit our welcoming community. Your ideal Amarillo apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-f485-775b-8778-be9ac82bb810.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019cfb43-f485-775b-8778-be9ac82bb810",
    "storage_key": "property/6767906449165613/019cfb43-f485-775b-8778-be9ac82bb810.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "216",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.53703703703704",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions May Apply - Ask leasing office for details.",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://newportapartmentsamarillo.securecafe.com/onlineleasing/newport-amarillo-apts/floorplans.aspx",
  "property_resident_portal_url": "https://newportapartmentsamarillo.securecafe.com/residentservices/newport-amarillo-apts/userlogin.aspx",
  "property_apply_now_url": "https://newportapartmentsamarillo.securecafe.com/onlineleasing/newport-amarillo-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-c5e4-76b5-86ad-6c691a714f40.webp",
  "property_primary_logo_media": {
    "alt_text": "Newport Apartment Homes logo.",
    "public_id": "019cfb42-c5e4-76b5-86ad-6c691a714f40",
    "storage_key": "property/6767906449165613/019cfb42-c5e4-76b5-86ad-6c691a714f40.webp",
    "width": 400,
    "height": 180
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-eaed-77e4-b634-a160caa72369.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb43-eaed-77e4-b634-a160caa72369",
    "storage_key": "property/6767906449165613/019cfb43-eaed-77e4-b634-a160caa72369.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb44-07c8-751c-a595-a09e80f26211.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Newport Apartment Homes logo",
    "public_id": "019cfb44-07c8-751c-a595-a09e80f26211",
    "storage_key": "property/6767906449165613/019cfb44-07c8-751c-a595-a09e80f26211.webp",
    "width": 400,
    "height": 180
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb44-169e-76d9-9a7f-2d19ce99840e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Newport Apartment Homes logo",
    "public_id": "019cfb44-169e-76d9-9a7f-2d19ce99840e",
    "storage_key": "property/6767906449165613/019cfb44-169e-76d9-9a7f-2d19ce99840e.webp",
    "width": 400,
    "height": 180
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#54504a",
  "property_secondary_color": "#80949f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "911 - 911",
  "property_sqft_min": "911",
  "property_sqft_max": "911",
  "property_price_range": "1284 - 1344",
  "property_price_min": "1284",
  "property_price_max": "1344",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/newport.amarillo/videos/",
  "property_instagram_url": "https://www.instagram.com/newportamarillo/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ35QcMA5QAYcR7YkS8PAIxlk",
  "property_youtube_url": "https://www.youtube.com/watch?v=b3um3zZovDs",
  "property_yelp_url": "https://www.yelp.com/biz/newport-amarillo",
  "property_tiktok_url": "https://www.tiktok.com/@newportamarillo",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Newport Amarillo Apts",
  "property_home_romance_title": "Experience Serenity in Your Perfect Apartment Retreat",
  "property_home_amenities_blurb": "At Newport Amarillo Apts, your ideal sanctuary awaits in the heart of Texas. Choose from spacious one and two-bedroom floor plans, designed for comfort and convenience. Enjoy serene outdoor spaces, relax by the pool, or unwind with friends in our clubhouse. Amenities like a dog park and business center elevate your lifestyle!",
  "property_home_floorplans_blurb": "Welcome to Newport Amarillo Apts, where comfort meets style in the heart of Amarillo, Texas. With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. Browse our available apartment homes today to find a perfect match that suits your lifestyle and elevates your everyday experience.",
  "property_home_gallery_blurb": "At Newport Amarillo Apts, modern living meets comfort. Choose from spacious one or two-bedroom floor plans, each equipped with luxurious amenities like a sparkling pool, dog park, and clubhouse. With on-site maintenance and high-speed internet, your ideal lifestyle is just a heartbeat away. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Newport Amarillo Apts, where comfort meets convenience in a vibrant community! Nestled near cultural gems like the American Quarter Horse Hall of Fame and the Don Harrington Discovery Center, your new home is perfect for exploring. Enjoy green spaces at the Amarillo Botanical Gardens and Wildcat Bluff Nature Center today!",
  "property_home_reviews_blurb": "At Newport Amarillo Apts, our residents value responsive service and a welcoming atmosphere. With rave reviews like, \"The staff and maintenance people took care of my problems quickly,\" your comfort is our priority. Join our community and experience the warmth of home in Amarillo, Texas—see what our residents are saying!",
  "property_neighborhood_blurb": "At Newport Amarillo Apts, the vibrant neighborhood offers more than just comfort—it invites adventure! Enjoy leisurely strolls at the Amarillo Botanical Gardens, explore the fascinating American Quarter Horse Hall of Fame, or catch a game at Hodgetown Stadium. Experience local charm and endless activities right at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Newport Amarillo Apts, where comfort meets convenience in every corner. Choose from stylish one- and two-bedroom floor plans, complemented by a refreshing pool, dog park, and inviting clubhouse. With modern amenities like high-speed internet, spacious patios, and in-unit laundry, your dream lifestyle is just a heartbeat away.",
  "property_applynow_blurb": "Experience the charm of Newport Amarillo Apts, where spacious one and two-bedroom layouts meet exceptional amenities. Enjoy sunny afternoons by the pool, vibrant gatherings in our clubhouse, or leisurely strolls in the dog park. Embrace comfort and convenience in Amarillo’s thriving community—lease your new home online today!",
  "property_contactus_blurb": "At Newport Amarillo Apts, your perfect home awaits with thoughtfully designed one and two-bedroom floor plans tailored for comfort and style in vibrant Amarillo, Texas. Our leasing team is ready to assist you with any questions — connect with us today to find your ideal living space!",
  "property_faqs_blurb": "At Newport Amarillo Apts in Amarillo, Texas, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Curious about our vibrant community? Dive into our FAQs page for all the insights you need about living here and experience the Newport difference today!",
  "property_floorplans_blurb": "At Newport Amarillo Apts, situated in the heart of Amarillo, Texas, you’ll find thoughtfully designed one and two-bedroom floor plans tailored to suit your lifestyle. Each layout offers the perfect blend of comfort and style. Browse our available apartment homes today and uncover the space that feels just right for you!",
  "property_gallery_blurb": "At Newport Amarillo Apts, each one and two-bedroom floor plan offers the perfect backdrop for your ideal lifestyle. Imagine sunny days by the pool, cozy evenings by the fireplace, and playing fetch at the dog park. Picture yourself enjoying our vibrant community spaces, from the sundeck to the picnic area!",
  "property_interactivemap_blurb": "Welcome to Newport Amarillo Apartments, where comfort meets convenience in the heart of Amarillo, Texas. Choose from spacious one- or two-bedroom layouts featuring modern amenities like a refreshing pool, inviting clubhouse, and a dog park for your furry friends. Unwind on the sundeck or discover your perfect home using our interactive community map!",
  "property_pets_blurb": "At Newport Amarillo Apts, your furry friends are part of the family! Nestled in vibrant Amarillo, TX, our community offers a welcoming space for you and your pets. Experience stylish living with modern amenities, where comfort and convenience come together. Reach out to our leasing office for pet policy details today!",
  "property_referafriend_blurb": "At Newport Amarillo Apts, we embrace community and connection in the heart of Amarillo, Texas. Choose from our spacious one and two-bedroom floor plans, designed for comfort and style. Share the joy of living here—refer a friend today and cultivate a vibrant neighborhood together!",
  "property_residentaccess_blurb": "Welcome to Newport Amarillo Apts, where modern living meets Texan charm. Choose from spacious one and two-bedroom floor plans tailored for your lifestyle. Enhance your experience by accessing our resident portal—pay rent effortlessly, schedule maintenance, and embrace the convenience of community living. Your new home awaits!",
  "property_reviews_blurb": "At Newport Amarillo Apts, our residents appreciate the swift and courteous service from our dedicated staff. One recent move-in mentioned, \"The office staff is already super helpful!\" Join a community where comfort and support elevate your living experience. See what our residents have to say about living at our community!",
  "property_created_at": "1753982387162",
  "property_scheduletour_blurb": "At Newport Amarillo Apts, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style in Amarillo, Texas. Ready to envision your new home? Schedule a tour today and hear firsthand what makes our community a cherished place to live!",
  "property_thankyou_blurb": "Thank you for reaching out to Newport Amarillo Apts! Your gateway to stylish living in Amarillo, Texas, awaits with our thoughtfully designed one and two-bedroom floor plans. Expect a team member to connect with you soon to help you take the next step toward your new home.",
  "property_virtualtours_blurb": "Step inside Newport Amarillo Apts and envision your new life in charming Amarillo, Texas. Our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Take a virtual tour today and see why our community is the ideal place to call home!",
  "property_copyright": "2025 All Rights Reserved. Newport Amarillo Apts",
  "property_seo_title_home": "Newport Amarillo Apts |  Apartments in Amarillo, Texas",
  "property_seo_description_home": "Welcome to Newport Amarillo Apts! Discover spacious one and two-bedroom homes with amenities like a pool, dog park, and clubhouse. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Amarillo, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Newport Amarillo Apts! From spacious one and two-bedroom layouts to stunning views, find the ideal floor plan for your next home.",
  "property_seo_title_amenities": "Amenities | Amarillo, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Newport Amarillo Apts! Dive into our vibrant community with a pool, dog park, clubhouse, and stylish apartment designs. Join us!",
  "property_seo_title_gallery": "Gallery | Apartments in Amarillo, Texas",
  "property_seo_description_gallery": "Discover your ideal lifestyle at Newport Amarillo Apts! Enjoy cozy one and two-bedroom layouts, a pool, and a dog park for ultimate relaxation!",
  "property_seo_title_virtualtours": "Virtual Tours | Newport Amarillo Apts Apartments",
  "property_seo_description_virtualtours": "Experience luxury living at Newport Amarillo Apts! Take a virtual tour of our stunning one and two-bedroom apartments in the heart of Amarillo, TX.",
  "property_seo_title_interactivemap": "Interactive Map | Newport Amarillo Apts Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Newport Amarillo Apts! From one and two-bedroom layouts to amenities like a dog park, pool, and more. Build community today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Amarillo, Texas",
  "property_seo_description_neighborhood": "Discover the charm of Newport Amarillo Apts in Amarillo, TX, with its vibrant neighborhood and nearby attractions that make it special!",
  "property_seo_title_contact": "Contact Us | Newport Amarillo Apts",
  "property_seo_description_contact": "Connect with Newport Amarillo Apts in Texas! Whether you need info on one or two-bedroom floor plans, our leasing team is ready to help. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Amarillo, Texas",
  "property_seo_description_faqs": "Get the answers you seek at Newport Amarillo Apts! Our FAQs page covers everything from amenities to floor plans in vibrant Amarillo, Texas.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Amarillo, Texas",
  "property_seo_description_reviews": "Join the vibrant community at Newport Amarillo Apts! Read resident reviews and see why our spacious units and top-notch amenities make life here exceptional!",
  "property_seo_title_applynow": "Apply Now | Apartments in Amarillo, Texas",
  "property_seo_description_applynow": "Discover comfort at Newport Amarillo Apts! Choose spacious one or two-bedroom designs with premium amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Newport Amarillo Apts",
  "property_seo_description_residentaccess": "Log in to your Newport Amarillo Apts resident portal for rent payments, maintenance requests, and community updates. Your convenience awaits in Amarillo!",
  "property_seo_title_referafriend": "Refer A Friend | Newport Amarillo Apts",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Newport Amarillo Apts and enjoy exclusive perks together in our vibrant Texas community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Newport Amarillo Apts",
  "property_seo_description_scheduletour": "Experience vibrant living at Newport Amarillo Apts! Schedule your tour today and step into a community where comfort meets convenience in the heart of Texas.",
  "property_seo_title_privacy": "Privacy Policy | Newport Amarillo Apts",
  "property_seo_description_privacy": "Your privacy matters at Newport Amarillo Apts. Check out our policy to learn how we protect your information while you enjoy our vibrant community in Amarillo.",
  "property_seo_title_accessibility": "Website Accessibility | Newport Amarillo Apts",
  "property_seo_description_accessibility": "Newport Amarillo Apts promotes digital inclusion, making our community accessible for everyone. Join us in creating a welcoming space for all!",
  "property_seo_title_sitemap": "Sitemap | Newport Amarillo Apts",
  "property_seo_description_sitemap": "Navigate your way to your new home at Newport Amarillo Apts! Check out our sitemap for easy access to amenities, floor plans, and all that awaits you.",
  "property_seo_title_thankyou": "Thank You | Newport Amarillo Apts",
  "property_seo_description_thankyou": "Thank you for reaching out to Newport Amarillo Apts! Our team is eager to assist you in finding your perfect home in Amarillo. Stay tuned for our reply!",
  "property_seo_title_pets": "Pet Policy | Apartments in Amarillo, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865428401",
  "amenities": [
    {
      "id": "custom_aa73fb75-8c9b-4b19-8c17-0c4c1d1e864d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Grill and Chill Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da1745e2-1fbc-4cb2-93c6-08248f6b6f4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91e9ea26-f555-4bb0-9f97-bb2fd849d478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyards",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49a7738e-24f4-47ea-bc3c-1af060152514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5820399-bc17-484f-8781-e1064b5c04c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_adbea462-e533-4b4c-ac4a-dec9f80776ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Laundry Facility with Smart‑Pay/Coin Operated",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f01fe63-35e6-4bea-9a43-7f08b3a6d482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f7f724c-169f-4fb9-a774-7d38f937044e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Onsite Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b859b4a-a46a-4c42-9747-bbb103647cd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4ad6a23-3a98-4e79-8968-7dd9c8a1459c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ce02965-cf23-4701-a8b1-aaeb944acba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed3f30fa-b53a-4cde-a9ee-2fbf677a3fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Patio Seating with TV",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cdeac182-0ed1-42cd-8168-acc6dc904c83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with Shuffle Board",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d34fc56-9247-4c5c-9d47-6a1a4968b3dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae960174-428b-4c68-b313-0a0668c79ba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4871437-cdc4-4a85-89ed-d29e977eb9a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "In‑Home Fireplace*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_889d7adc-f626-401b-94ff-1fb4ead4ede3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony/Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da6f5a32-296a-4ef1-9967-acd021a29482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9719483c-56f0-40e9-b3f2-3e490094f43f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7f28dd1-1b46-43c4-8f39-a1b2e3865358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Interiors*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed4f7e77-e02e-4ac9-b46d-f1e140c8a9b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be84acf7-d985-482d-9a41-5620f7dfdc6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43833b48-5684-418b-b8ce-ad3c3086e72f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7108e66-4a37-49a9-8b3e-bf90fdfbc3bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "external_id": "false",
      "title": "Get Connected To Super‑Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_91ebde18-8d68-4921-b9ac-80dcc6e3a08f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-4690-77b9-9370-186fb12a3802.webp",
      "image_media": {
        "alt_text": "Outdoor community courtyard with a playground and apartment buildings in the background.",
        "public_id": "019d20af-4690-77b9-9370-186fb12a3802",
        "storage_key": "property/6767906449165613/019d20af-4690-77b9-9370-186fb12a3802.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Community courtyard at the apartment complex featuring a grassy play area and surrounding residential buildings.",
      "link": "",
      "alt_text": "Outdoor community courtyard with a playground and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-5ecb-76d7-91c8-e699de554f78.webp"
    },
    {
      "id": "custom_86ba1f75-525c-4aa3-afda-8a069c5bae36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-4780-745c-a70d-bc0e4dfcd84b.webp",
      "image_media": {
        "alt_text": "Exterior view of Newport leasing office sign on brick building with landscaped lawn.",
        "public_id": "019d20af-4780-745c-a70d-bc0e4dfcd84b",
        "storage_key": "property/6767906449165613/019d20af-4780-745c-a70d-bc0e4dfcd84b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of Newport leasing office at a multifamily community, featuring brick buildings, manicured lawn, and rose bushes.",
      "link": "",
      "alt_text": "Exterior view of Newport leasing office sign on brick building with landscaped lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-8a13-7639-a709-f7ec50588be7.webp"
    },
    {
      "id": "custom_b052518f-b186-4506-b875-a24ec8808af2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-4776-7493-8240-bb6f9f75c84a.webp",
      "image_media": {
        "alt_text": "Outdoor communal grilling area with a stone patio, tables, and umbrellas in an apartment courtyard.",
        "public_id": "019d20af-4776-7493-8240-bb6f9f75c84a",
        "storage_key": "property/6767906449165613/019d20af-4776-7493-8240-bb6f9f75c84a.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Outdoor communal grilling area with a stone patio, tables, and umbrellas within the apartment community.",
      "link": "",
      "alt_text": "Outdoor communal grilling area with a stone patio, tables, and umbrellas in an apartment courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-c635-7015-825e-6d616166923c.webp"
    },
    {
      "id": "custom_335683b7-45b6-445b-b700-5f9525f23c1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-47f3-764f-8b7b-6ac9fbe534d5.webp",
      "image_media": {
        "alt_text": "Outdoor community deck with blue chairs, umbrellas, steps, and railing under trees.",
        "public_id": "019d20af-47f3-764f-8b7b-6ac9fbe534d5",
        "storage_key": "property/6767906449165613/019d20af-47f3-764f-8b7b-6ac9fbe534d5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor resident amenity area with a wooden deck, shaded seating, and umbrellas at a multifamily community.",
      "link": "",
      "alt_text": "Outdoor community deck with blue chairs, umbrellas, steps, and railing under trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-72ee-772b-93d8-9f40bb119257.webp"
    },
    {
      "id": "custom_4a1b74a2-dd26-4780-9b5d-8c3935e4dc34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-5183-77bc-8da2-7191d28983b9.webp",
      "image_media": {
        "alt_text": "Outdoor communal pool with blue water, lounge chairs, and a shaded seating pavilion.",
        "public_id": "019d20af-5183-77bc-8da2-7191d28983b9",
        "storage_key": "property/6767906449165613/019d20af-5183-77bc-8da2-7191d28983b9.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Bright outdoor pool area with lounge chairs and a shaded pavilion, part of the community amenities.",
      "link": "",
      "alt_text": "Outdoor communal pool with blue water, lounge chairs, and a shaded seating pavilion.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-d100-7660-99e8-196cab9b9e6e.webp"
    },
    {
      "id": "custom_8a25336f-0f26-461f-8d32-4e063da92f82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-5392-74cd-af31-faf21ba9891f.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with blue water, lounge chairs, and surrounding apartment buildings.",
        "public_id": "019d20af-5392-74cd-af31-faf21ba9891f",
        "storage_key": "property/6767906449165613/019d20af-5392-74cd-af31-faf21ba9891f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily community with lounge seating and well-maintained surroundings.",
      "link": "",
      "alt_text": "Outdoor community pool with blue water, lounge chairs, and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-81f4-759e-a575-f02a7d755bfb.webp"
    },
    {
      "id": "custom_8f2521d3-7110-4cd0-8ea0-0d9e0e1d532d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-54ff-75cc-85ca-b5f9b8128bf6.webp",
      "image_media": {
        "alt_text": "Covered brick patio with outdoor seating and a hanging porch swing in a courtyard.",
        "public_id": "019d20af-54ff-75cc-85ca-b5f9b8128bf6",
        "storage_key": "property/6767906449165613/019d20af-54ff-75cc-85ca-b5f9b8128bf6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Shared outdoor courtyard with brick patio, seating, a hanging porch swing, and planters for residents.",
      "link": "",
      "alt_text": "Covered brick patio with outdoor seating and a hanging porch swing in a courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-5fe2-74c9-813f-5e04b798b9e6.webp"
    },
    {
      "id": "custom_71ce94aa-98cd-4d17-a032-905e1d0c371f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-5598-71c1-be22-7d74af120355.webp",
      "image_media": {
        "alt_text": "Interior apartment office with wood desk, computer, and printer against blue patterned wallpaper.",
        "public_id": "019d20af-5598-71c1-be22-7d74af120355",
        "storage_key": "property/6767906449165613/019d20af-5598-71c1-be22-7d74af120355.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Modern apartment study area featuring a wood desk, computer, and printer in a blue-patterned room.",
      "link": "",
      "alt_text": "Interior apartment office with wood desk, computer, and printer against blue patterned wallpaper.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-cef8-7160-9640-fb4b902563eb.webp"
    },
    {
      "id": "custom_39b8070c-d12a-4fbd-a15f-5dee433575e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-5f26-77a9-b12a-65fdd2445f82.webp",
      "image_media": {
        "alt_text": "Modern lobby with a gas fireplace, comfortable seating, and large front windows.",
        "public_id": "019d20af-5f26-77a9-b12a-65fdd2445f82",
        "storage_key": "property/6767906449165613/019d20af-5f26-77a9-b12a-65fdd2445f82.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright community lounge with a fireplace, contemporary seating, and an open path to the leasing desk.",
      "link": "",
      "alt_text": "Modern lobby with a gas fireplace, comfortable seating, and large front windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-86ce-70ef-bcd4-4b9dcecaf6e7.webp"
    },
    {
      "id": "custom_d8244b7d-fcc1-4752-9573-f5aef644f355",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-615e-77c3-ad66-f06868e09b50.webp",
      "image_media": {
        "alt_text": "Bright apartment community lobby with reception desk, seating, and glass doors.",
        "public_id": "019d20af-615e-77c3-ad66-f06868e09b50",
        "storage_key": "property/6767906449165613/019d20af-615e-77c3-ad66-f06868e09b50.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern, open lobby with a reception desk, seating area, and glass entry doors.",
      "link": "",
      "alt_text": "Bright apartment community lobby with reception desk, seating, and glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-68f5-736c-9165-92e85f3ba7bf.webp"
    },
    {
      "id": "custom_6df1d683-aa72-455c-8c2e-0856ae3818ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-61f5-740f-9a27-f31e1fceb322.webp",
      "image_media": {
        "alt_text": "Community laundry room with row of white washers and dryers against light green walls.",
        "public_id": "019d20af-61f5-740f-9a27-f31e1fceb322",
        "storage_key": "property/6767906449165613/019d20af-61f5-740f-9a27-f31e1fceb322.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "On-site laundry facility with multiple washers and dryers in a communal space for residents.",
      "link": "",
      "alt_text": "Community laundry room with row of white washers and dryers against light green walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-6060-7144-bbfa-b345552e00e3.webp"
    },
    {
      "id": "custom_06b16280-43e4-4b12-9966-d9036da6aaa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-63df-763c-bfea-89d678ad8dc2.webp",
      "image_media": {
        "alt_text": "Bright community lounge with white sofas, chairs, and large windows.",
        "public_id": "019d20af-63df-763c-bfea-89d678ad8dc2",
        "storage_key": "property/6767906449165613/019d20af-63df-763c-bfea-89d678ad8dc2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious resident lounge with modern seating, a dining area, and large windows bringing in natural light.",
      "link": "",
      "alt_text": "Bright community lounge with white sofas, chairs, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-7153-7589-b0c5-6a500bae1bb1.webp"
    },
    {
      "id": "custom_7a87ad00-d753-49af-a74e-5b78a9c1a48c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-6a63-7179-a411-86a84c99cf29.webp",
      "image_media": {
        "alt_text": "Bright community lounge with blue cabinetry, seating booth, round table, and large windows.",
        "public_id": "019d20af-6a63-7179-a411-86a84c99cf29",
        "storage_key": "property/6767906449165613/019d20af-6a63-7179-a411-86a84c99cf29.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern clubhouse-style lounge with a kitchenette and comfortable seating for residents.",
      "link": "",
      "alt_text": "Bright community lounge with blue cabinetry, seating booth, round table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-7a06-7098-a9b6-772c454d17c5.webp"
    },
    {
      "id": "custom_b4d800db-3f99-49f5-8348-c77c8d704295",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-6bc1-71cb-b8b7-1fa7485fa55f.webp",
      "image_media": {
        "alt_text": "Indoor mailroom with rows of metal mailboxes on light blue walls.",
        "public_id": "019d20af-6bc1-71cb-b8b7-1fa7485fa55f",
        "storage_key": "property/6767906449165613/019d20af-6bc1-71cb-b8b7-1fa7485fa55f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Common building area with resident mailboxes and tiled floor.",
      "link": "",
      "alt_text": "Indoor mailroom with rows of metal mailboxes on light blue walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-9004-776f-bb6e-de8d19883b43.webp"
    },
    {
      "id": "custom_5d1d7b56-a4c2-4a93-a60d-4ad381c26211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-6cac-7318-bef6-5b37f123ffba.webp",
      "image_media": {
        "alt_text": "Modern apartment community lobby with seating, artwork, and glass doors.",
        "public_id": "019d20af-6cac-7318-bef6-5b37f123ffba",
        "storage_key": "property/6767906449165613/019d20af-6cac-7318-bef6-5b37f123ffba.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious, contemporary resident lobby with seating areas, artwork, and open sightlines to exterior doors.",
      "link": "",
      "alt_text": "Modern apartment community lobby with seating, artwork, and glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-925d-7705-a25a-74898aac3b8c.webp"
    },
    {
      "id": "custom_9b80cb5a-dd01-496a-9220-cb0326426d08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-6f92-70b5-9aea-13446078ae08.webp",
      "image_media": {
        "alt_text": "Cozy living room with fireplace, tan sofa, green chair, and sliding door to balcony.",
        "public_id": "019d20af-6f92-70b5-9aea-13446078ae08",
        "storage_key": "property/6767906449165613/019d20af-6f92-70b5-9aea-13446078ae08.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment featuring a fireplace, a tan sofa, and a sliding door to a balcony.",
      "link": "",
      "alt_text": "Cozy living room with fireplace, tan sofa, green chair, and sliding door to balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-d648-7238-a053-b0418944ef19.webp"
    },
    {
      "id": "custom_1c0894c5-bf56-46ef-a688-569d41370488",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-772e-73a0-900e-18dfa23c23bc.webp",
      "image_media": {
        "alt_text": "Leasing office space with desk, dual monitors, and two guest chairs.",
        "public_id": "019d20af-772e-73a0-900e-18dfa23c23bc",
        "storage_key": "property/6767906449165613/019d20af-772e-73a0-900e-18dfa23c23bc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern leasing office with a wooden desk, dual monitors, leather chair, and guest seating; bright windows and wall art.",
      "link": "",
      "alt_text": "Leasing office space with desk, dual monitors, and two guest chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-690f-74db-b281-a58a3eb76e8e.webp"
    },
    {
      "id": "custom_b2e78d32-05bb-4907-93cc-94a440db03b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-7746-729a-94a9-6e9a87548a5e.webp",
      "image_media": {
        "alt_text": "Laundry closet with two front-loading washers and a dryer.",
        "public_id": "019d20af-7746-729a-94a9-6e9a87548a5e",
        "storage_key": "property/6767906449165613/019d20af-7746-729a-94a9-6e9a87548a5e.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "In-unit laundry area with side-by-side washer and dryer in a compact closet.",
      "link": "",
      "alt_text": "Laundry closet with two front-loading washers and a dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-6343-711f-ae6b-0ded0ccd77b6.webp"
    },
    {
      "id": "custom_45b1c165-de34-4cfc-8c39-ff90a6f32322",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-7aba-7639-82ec-cd10093826a2.webp",
      "image_media": {
        "alt_text": "Hallway view in an apartment showing two open bedroom doors with beds.",
        "public_id": "019d20af-7aba-7639-82ec-cd10093826a2",
        "storage_key": "property/6767906449165613/019d20af-7aba-7639-82ec-cd10093826a2.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Interior of a modern apartment featuring a carpeted hallway and two bedrooms.",
      "link": "",
      "alt_text": "Hallway view in an apartment showing two open bedroom doors with beds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-6998-771d-b60c-4d95625f2248.webp"
    },
    {
      "id": "custom_04eedcaa-cbfb-472e-a99e-4099596bf9e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-7b19-703c-a6ad-3a104bf7ec21.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a wooden vanity, sink, toilet, and a white-tiled bathtub/shower.",
        "public_id": "019d20af-7b19-703c-a6ad-3a104bf7ec21",
        "storage_key": "property/6767906449165613/019d20af-7b19-703c-a6ad-3a104bf7ec21.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a wooden vanity, sink, toilet, and a white tile bathtub/shower, accented by purple towels.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a wooden vanity, sink, toilet, and a white-tiled bathtub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-731c-7049-aecd-1ab69bfe0ddd.webp"
    },
    {
      "id": "custom_5f0e0dde-3681-4bf5-8f7d-b77951db8625",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-8280-737e-bcaf-ad47488072e1.webp",
      "image_media": {
        "alt_text": "Laundry area with a washer on the right, a LAUNDRY sign, and wall art above.",
        "public_id": "019d20af-8280-737e-bcaf-ad47488072e1",
        "storage_key": "property/6767906449165613/019d20af-8280-737e-bcaf-ad47488072e1.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "A compact apartment laundry area with a white appliance, a LAUNDRY sign, and decorative wall art.",
      "link": "",
      "alt_text": "Laundry area with a washer on the right, a LAUNDRY sign, and wall art above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-7643-71de-8342-f02ef9e38917.webp"
    },
    {
      "id": "custom_aac116df-32dc-4eaa-988e-1f4cda918295",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-8461-7208-81d3-5ec26d07406a.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, fireplace, and sliding glass door to a balcony.",
        "public_id": "019d20af-8461-7208-81d3-5ec26d07406a",
        "storage_key": "property/6767906449165613/019d20af-8461-7208-81d3-5ec26d07406a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with a fireplace, balcony access, and mid-century decor.",
      "link": "",
      "alt_text": "Living room with beige sofa, fireplace, and sliding glass door to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-79fb-77fc-98a2-f68077c12f0c.webp"
    },
    {
      "id": "custom_ecc02288-6dcd-43d8-963a-b9d7905869ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-8542-746e-bad4-61428611de2b.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a wooden bed, nightstands, blue bedding, ceiling fan, and a window with blue curtains.",
        "public_id": "019d20af-8542-746e-bad4-61428611de2b",
        "storage_key": "property/6767906449165613/019d20af-8542-746e-bad4-61428611de2b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylishly furnished apartment bedroom featuring blue accents, wood furniture, and soft lighting.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a wooden bed, nightstands, blue bedding, ceiling fan, and a window with blue curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-79f5-77a1-b4ff-284051090fb9.webp"
    },
    {
      "id": "custom_e3f299be-5b1d-4c82-8334-599e250b41de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-85a7-75d3-bb8e-c4988066f458.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a wooden headboard, floral bedding, and a glass-topped nightstand beside a window.",
        "public_id": "019d20af-85a7-75d3-bb8e-c4988066f458",
        "storage_key": "property/6767906449165613/019d20af-85a7-75d3-bb8e-c4988066f458.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with natural light, featuring a wood headboard, botanical bedding, and a glass-topped nightstand.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a wooden headboard, floral bedding, and a glass-topped nightstand beside a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-7af9-7422-8577-b6631406ff49.webp"
    },
    {
      "id": "custom_bf56a28f-5c2f-4a13-81b1-fc48108c5646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-8c41-72a4-9382-4994e0b97728.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a wooden bed, nightstand, dresser, window, and ceiling fan.",
        "public_id": "019d20af-8c41-72a4-9382-4994e0b97728",
        "storage_key": "property/6767906449165613/019d20af-8c41-72a4-9382-4994e0b97728.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a wooden bed, matching nightstand and dresser, ceiling fan, and bright window.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a wooden bed, nightstand, dresser, window, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-88aa-742a-aa87-46d6c861dd6e.webp"
    },
    {
      "id": "custom_c215eff2-b80a-4de6-ad43-f64f6e9e1931",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-8e5f-74e8-869c-b166e4824506.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a sofa, chairs, built-in shelves, and a sliding balcony door.",
        "public_id": "019d20af-8e5f-74e8-869c-b166e4824506",
        "storage_key": "property/6767906449165613/019d20af-8e5f-74e8-869c-b166e4824506.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright living room in a stylish apartment featuring neutral tones, wall art, built-in shelving, and a sliding glass door to a balcony.",
      "link": "",
      "alt_text": "Living room in an apartment with a sofa, chairs, built-in shelves, and a sliding balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-860a-762a-8c71-7f1b8a615557.webp"
    },
    {
      "id": "custom_1c997036-0a41-41f0-b562-041b88af0f5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-8fd5-70cd-a042-05e0f9e17f7d.webp",
      "image_media": {
        "alt_text": "Kitchen in apartment with white appliances, wooden cabinets, and a dining area visible in the back.",
        "public_id": "019d20af-8fd5-70cd-a042-05e0f9e17f7d",
        "storage_key": "property/6767906449165613/019d20af-8fd5-70cd-a042-05e0f9e17f7d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright kitchen in a modern apartment with white appliances and light wood cabinetry, opening to a dining space and living area.",
      "link": "",
      "alt_text": "Kitchen in apartment with white appliances, wooden cabinets, and a dining area visible in the back.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-86aa-776b-b4d1-437b8f1d3b82.webp"
    },
    {
      "id": "custom_3ba47324-69a3-464e-9885-f61b112416f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-9426-74c6-91f4-6dc9b9328ab2.webp",
      "image_media": {
        "alt_text": "Dining area with a light wood table and stools, open shelving, and a white refrigerator.",
        "public_id": "019d20af-9426-74c6-91f4-6dc9b9328ab2",
        "storage_key": "property/6767906449165613/019d20af-9426-74c6-91f4-6dc9b9328ab2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment dining space with a minimalist table, stools, open shelving, and a compact kitchen.",
      "link": "",
      "alt_text": "Dining area with a light wood table and stools, open shelving, and a white refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-8a40-71ff-a9d1-bcea97abefcb.webp"
    },
    {
      "id": "custom_655173dc-e6b0-4df8-883d-dec50d6aa06a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-97f1-70a3-a07e-00384c63c87d.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a light gray sofa, coffee table, and open kitchen pass-through.",
        "public_id": "019d20af-97f1-70a3-a07e-00384c63c87d",
        "storage_key": "property/6767906449165613/019d20af-97f1-70a3-a07e-00384c63c87d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment living area with a neutral palette, artwork, and an open kitchen pass-through.",
      "link": "",
      "alt_text": "Living room in an apartment with a light gray sofa, coffee table, and open kitchen pass-through.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-9803-72c9-8ee0-fcf551ce99f8.webp"
    },
    {
      "id": "custom_b52330ec-deec-45e5-a7a4-864d3b4c5739",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-9b46-750a-9c22-bb136804a378.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with white fridge, stove, microwave, wood cabinets, and laminate flooring.",
        "public_id": "019d20af-9b46-750a-9c22-bb136804a378",
        "storage_key": "property/6767906449165613/019d20af-9b46-750a-9c22-bb136804a378.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy galley-style kitchen in a multifamily unit with white appliances and wood cabinetry.",
      "link": "",
      "alt_text": "Kitchen in an apartment with white fridge, stove, microwave, wood cabinets, and laminate flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-943e-765f-92d1-6d11d0d1d3be.webp"
    },
    {
      "id": "custom_f86a70ec-59ca-4a01-8a4c-fcbc4708c40c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-9ffe-76da-9e08-586492c22c09.webp",
      "image_media": {
        "alt_text": "Galley-style apartment kitchen with white appliances, wooden cabinets, and light vinyl flooring.",
        "public_id": "019d20af-9ffe-76da-9e08-586492c22c09",
        "storage_key": "property/6767906449165613/019d20af-9ffe-76da-9e08-586492c22c09.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior view of a compact apartment kitchen with white appliances, a full-size fridge, stove, microwave, and wooden cabinets.",
      "link": "",
      "alt_text": "Galley-style apartment kitchen with white appliances, wooden cabinets, and light vinyl flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-9581-745d-9115-8dce8760fbd0.webp"
    },
    {
      "id": "custom_8d3ed9b2-2ce8-4799-bbf5-daf004828568",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-a530-722f-b3ab-f082cf8183d3.webp",
      "image_media": {
        "alt_text": "Small dining nook with a round black table, two green-cushioned chairs, and wall art.",
        "public_id": "019d20af-a530-722f-b3ab-f082cf8183d3",
        "storage_key": "property/6767906449165613/019d20af-a530-722f-b3ab-f082cf8183d3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment dining area with a round table, two chairs, and simple wall art.",
      "link": "",
      "alt_text": "Small dining nook with a round black table, two green-cushioned chairs, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-9671-7386-a312-362cc7846f35.webp"
    },
    {
      "id": "custom_018fe9c6-cc9b-445b-8403-9d9f686f9ebf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-a896-7109-92a2-66f28d70271d.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white walls, shelving, and double clothing rods.",
        "public_id": "019d20af-a896-7109-92a2-66f28d70271d",
        "storage_key": "property/6767906449165613/019d20af-a896-7109-92a2-66f28d70271d.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Interior photo of a walk-in closet in an apartment, showing white walls, ceiling shelves, and hanging rods.",
      "link": "",
      "alt_text": "Walk-in closet with white walls, shelving, and double clothing rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-6336-70eb-ae18-aff3445608da.webp"
    },
    {
      "id": "custom_e2c3effd-5bda-4e3d-9e7e-5d7ec611ebeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-aac7-7288-ba42-928635813cea.webp",
      "image_media": {
        "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
        "public_id": "019d20af-aac7-7288-ba42-928635813cea",
        "storage_key": "property/6767906449165613/019d20af-aac7-7288-ba42-928635813cea.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "Silhouette of a city skyline at sunset, used as an exterior backdrop in property photo galleries.",
      "link": "",
      "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-d685-73b7-9ca6-b55092c3b931.webp"
    },
    {
      "id": "custom_5c0d4dd0-82e4-4a93-bf4f-14ee6e1318a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-aec0-72fb-a335-cdd6daf5c8f7.webp",
      "image_media": {
        "alt_text": "Aerial view of a city neighborhood with a church in the foreground.",
        "public_id": "019d20af-aec0-72fb-a335-cdd6daf5c8f7",
        "storage_key": "property/6767906449165613/019d20af-aec0-72fb-a335-cdd6daf5c8f7.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Bird's-eye view of a dense urban area with houses, streets, and distant high-rises.",
      "link": "",
      "alt_text": "Aerial view of a city neighborhood with a church in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-d7b8-708a-a914-861da620e783.webp"
    },
    {
      "id": "custom_0fefb1ee-5adf-4766-bb9b-63bae0d0fbda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d20af-b18f-736b-8104-9470cfc37510.webp",
      "image_media": {
        "alt_text": "Orange statue atop a rock pedestal beside a pond in a landscaped outdoor area.",
        "public_id": "019d20af-b18f-736b-8104-9470cfc37510",
        "storage_key": "property/6767906449165613/019d20af-b18f-736b-8104-9470cfc37510.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Outdoor community feature: a striking orange statue on a rock pedestal overlooking a pond with landscaped surroundings.",
      "link": "",
      "alt_text": "Orange statue atop a rock pedestal beside a pond in a landscaped outdoor area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165613/019cfb42-d823-751d-aa80-4d395fce461b.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_981a8926-9f05-4095-8db9-33b9f79df5a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2805 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain steakhouse serving fall-off-the-bone ribs and other American fare in a lively setting.",
      "poi_long_description": "People say this steakhouse serves tender chicken fried steak, delicious rolls, and flavorful ribs. They highlight the reasonable prices and fun, Texas-themed atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0a4c-7358-8b0b-9aa8a48d56cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0a4c-7358-8b0b-9aa8a48d56cc",
        "storage_key": "property/6767906449165613/019cfb43-0a4c-7358-8b0b-9aa8a48d56cc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328858651283659231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.1940532",
      "poi_longitude": "-101.8676751",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-352-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQj8GMpPAYcR35k_aU57Mi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c562125c-a12a-4599-b010-2bdfe436bb11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "2813 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Laid-back chain serving burgers, beer and pizza, plus sports on multiple TVs.",
      "poi_long_description": "People say this American restaurant serves delicious pizza, burgers, fish and chips, and wings. They highlight the fresh ingredients, homemade Italian sausage, and crispy, chewy pizza crust. They also like the dog-friendly patio, the sports bar atmosphere with large screen TVs, and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0a3b-72b8-b6e5-fc404692892c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0a3b-72b8-b6e5-fc404692892c",
        "storage_key": "property/6767906449165613/019cfb43-0a3b-72b8-b6e5-fc404692892c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bubbas33.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15317791946731671629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "35.1937663",
      "poi_longitude": "-101.8691615",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-353-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD99rJspPAYcRTdBHUJ66k9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_20eecfe4-0f0f-4e8c-8a2b-c39b6e41df16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "2323 E Interstate 40 Hwy, Amarillo, TX 79104, USA",
      "poi_short_description": "American chain known for fried chicken, breakfast staples, gift shop and porch rockers.",
      "poi_long_description": "People say this restaurant serves delicious catfish, chicken and dumplings, and meatloaf. They also highlight the quick service, reasonable prices, and attentive staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0a1c-70aa-99f6-8e8add30641e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0a1c-70aa-99f6-8e8add30641e",
        "storage_key": "property/6767906449165613/019cfb43-0a1c-70aa-99f6-8e8add30641e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/tx/amarillo/210/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207491288533106944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.1940806",
      "poi_longitude": "-101.8111376",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-372-2034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_dgNCVPAYcRAAEVw1lvSrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_385a3b33-6bb1-48ff-a0e2-83d1c1dd69a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2525 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches and waffle fries, plus breakfast items and a kids' menu.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and lemonade. They highlight the food is fresh and hot, and the staff are friendly and attentive. They also like the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0a14-74a8-9ccc-a15cb416be7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0a14-74a8-9ccc-a15cb416be7c",
        "storage_key": "property/6767906449165613/019cfb43-0a14-74a8-9ccc-a15cb416be7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/georgia-street?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898565818159840665&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.18604200000001",
      "poi_longitude": "-101.8656726",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-358-8055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_QXe7hPAYcRmb09sSrFXok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_112f981f-42d9-48bb-ba86-5d2a54c61c7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2812 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Casual chain eatery specializing in chicken fingers, fries and lemonade.",
      "poi_long_description": "People say this fast food restaurant serves crispy chicken tenders, chicken sandwiches, and toast. They highlight the fast service and the fresh, hot food. They also like the clean environment and friendly, knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0a61-745e-8b66-6b982414d0a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0a61-745e-8b66-6b982414d0a6",
        "storage_key": "property/6767906449165613/019cfb43-0a61-745e-8b66-6b982414d0a6.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/amarillo/2812-s-georgia-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=905577921826965201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.1828248",
      "poi_longitude": "-101.8668346",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-356-0140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUy4qoxPAYcR0cbualJCkQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c01ba2e7-b4a9-4067-b65f-091d204b10be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Westgate Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 I-40, Amarillo, TX 79121, USA",
      "poi_short_description": "Spacious shopping hub with familiar retailers and a cinema alongside an arcade and a playground.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a food court. They also highlight the clean and well-maintained environment.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-09e1-7460-b337-d8da3ca13ef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-09e1-7460-b337-d8da3ca13ef8",
        "storage_key": "property/6767906449165613/019cfb43-09e1-7460-b337-d8da3ca13ef8.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://www.westgatemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8872045046986861251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westgate-mall",
      "poi_latitude": "35.184043",
      "poi_longitude": "-101.9280617",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-7221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5aNuwVBQAYcRw2rq0PbVH3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1f375469-256f-44e7-b4ef-9c4201b8ec5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Sprawling home-improvement chain stocking tools, appliances, lumber, furniture, flooring, paint and plants along with gardening supplies.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are always willing to assist customers in finding the right products and completing their projects. They also highlight the wide selection of home furniture and supplies available at the store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0b14-70c9-885a-3771efbf32f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0b14-70c9-885a-3771efbf32f4",
        "storage_key": "property/6767906449165613/019cfb43-0b14-70c9-885a-3771efbf32f4.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/E-Amarillo/TX/Amarillo/79109/6831?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17449643067838617860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.1887022",
      "poi_longitude": "-101.8687317",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-468-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_XrzAchPAYcRBNngA-uVKfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_935c214b-6215-43f6-b6b8-e37fd1568ef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 S Western St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chains and department retailer featuring clothing and footwear, plus housewares and gifts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-09c5-76df-8b1f-56733fc2be3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-09c5-76df-8b1f-56733fc2be3b",
        "storage_key": "property/6767906449165613/019cfb43-09c5-76df-8b1f-56733fc2be3b.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/tx/amarillo/564/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13172599468811409494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.1892288",
      "poi_longitude": "-101.8809655",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-353-7087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQYcDKddPAYcRVtgA62x5zrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_c6590645-6eb4-4ad3-8e88-fe3cf910188a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "2530 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean grocery store that’s stocked with national brands alongside local ingredients, and has an on-site bakery and deli.",
      "poi_long_description": "People say this grocery store offers a wide selection of items, including fresh produce, quality meats, and a nice bakery. They highlight the clean store and friendly, helpful staff. They also like the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-09c7-74fa-819f-d0c49b6f29ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-09c7-74fa-819f-d0c49b6f29ac",
        "storage_key": "property/6767906449165613/019cfb43-09c7-74fa-819f-d0c49b6f29ac.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/amarillo/2530-s-georgia-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028910684191050097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "35.1862872",
      "poi_longitude": "-101.8681069",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-468-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bbd-777f-b2b4-bd9f1f501d52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bbd-777f-b2b4-bd9f1f501d52",
        "storage_key": "property/6767906449165613/019cfb43-1bbd-777f-b2b4-bd9f1f501d52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_27QvMdPAYcRccmrq1chct4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1f0ce917-a1b5-4f33-8a4c-114e4ad42a42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3030 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Chain selling discounted clothing, accessories and housewares.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0b1c-7107-bead-d6436ef41ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0b1c-7107-bead-d6436ef41ecc",
        "storage_key": "property/6767906449165613/019cfb43-0b1c-7107-bead-d6436ef41ecc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16582175913080698917&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.1797012",
      "poi_longitude": "-101.940193",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-355-8901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRJbg2BiO5H-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_3a24eb10-ee7c-4482-8370-7414922bdb1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo College",
      "poi_type": "Education",
      "poi_address": "2201 S Washington St #2411, Amarillo, TX 79109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0d86-76ab-a6ab-3e96286e0ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0d86-76ab-a6ab-3e96286e0ce2",
        "storage_key": "property/6767906449165613/019cfb43-0d86-76ab-a6ab-3e96286e0ce2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362103176866188035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college",
      "poi_latitude": "35.1877711",
      "poi_longitude": "-101.8482546",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhTxRNyhOAYcRA0vWlVcDj6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_257648e4-94c9-4d18-840a-f0391035430e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo College West Campus",
      "poi_type": "Education",
      "poi_address": "6222 SW 9th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0da7-7611-be77-d109d384c8fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0da7-7611-be77-d109d384c8fb",
        "storage_key": "property/6767906449165613/019cfb43-0da7-7611-be77-d109d384c8fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7615385847900468607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college-west-campus",
      "poi_latitude": "35.2068369",
      "poi_longitude": "-101.9072632",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxkyGsZRAYcRf_WkoxRJr2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0e4f88a3-fdac-4e9a-b6e6-0cece5ae36cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Hodgetown Stadium",
      "poi_type": "Entertainment",
      "poi_address": "715 S Buchanan St, Amarillo, TX 79101, USA",
      "poi_short_description": "Baseball stadium with fireworks, Star Wars theme nights, and other promotions, plus food and a restroom.",
      "poi_long_description": "People say this stadium offers exciting games, impressive fireworks displays, and fun entertainment between innings. They highlight the great atmosphere, comfortable seating, and clean facilities. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0e1c-71af-baa1-5eee5a4c9794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0e1c-71af-baa1-5eee5a4c9794",
        "storage_key": "property/6767906449165613/019cfb43-0e1c-71af-baa1-5eee5a4c9794.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.milb.com/amarillo/tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7306300840172905774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hodgetown-stadium",
      "poi_latitude": "35.205011",
      "poi_longitude": "-101.8317304",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-803-7762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b99-724b-8cd8-924ea80caa32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b99-724b-8cd8-924ea80caa32",
        "storage_key": "property/6767906449165613/019cfb43-1b99-724b-8cd8-924ea80caa32.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTRhSe6dPAYcRLuWkWOcxZWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_05847538-c9df-4acc-99d1-cae5b24ce4c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Don Harrington Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "1200 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Children's venue offering exhibits and a theater showcasing space shows and other films.",
      "poi_long_description": "Permanent exhibits on the universe & weather, plus a theater & visiting shows for toddlers to teens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0eb2-7639-9b19-949484ddc845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0eb2-7639-9b19-949484ddc845",
        "storage_key": "property/6767906449165613/019cfb43-0eb2-7639-9b19-949484ddc845.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverycenteramarillo.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=551b89ca-129c-4559-8dfb-452b2909f411",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217897852746957318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-harrington-discovery-center",
      "poi_latitude": "35.2000385",
      "poi_longitude": "-101.9132754",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-355-9547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ba3-7703-88c4-f7ff34e3af68",
        "storage_key": "property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwVFCrZRAYcRBoJhzhBob7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2fc30dce-998d-4f83-82c3-47a187416893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Bill's Backyard Classics",
      "poi_type": "Entertainment",
      "poi_address": "5309 S Washington St, Amarillo, TX 79110, USA",
      "poi_short_description": "Private, 30's-50's collection of over 100 vintage vehicles ranging from Model Ts to muscle cars, plus hot rods.",
      "poi_long_description": "People say this museum has an incredible collection of classic cars, lovingly restored and maintained in excellent condition. They highlight the vehicles are driveable and the tour guides are knowledgeable and engaging. They also like the friendly and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0ec1-756a-91aa-bd13b0937254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0ec1-756a-91aa-bd13b0937254",
        "storage_key": "property/6767906449165613/019cfb43-0ec1-756a-91aa-bd13b0937254.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.billsbackyardclassics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8333570560278974626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bills-backyard-classics",
      "poi_latitude": "35.154351",
      "poi_longitude": "-101.8477999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-373-8194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ba3-7703-88c4-f7ff34e3af68",
        "storage_key": "property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0Rzl35FAYcRotAUfEXKpnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d6560521-68f7-435b-8920-eac70b0431f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "American Quarter Horse Hall of Fame & Museum",
      "poi_type": "Entertainment",
      "poi_address": "2601 E Interstate Dr, Amarillo, TX 79104, USA",
      "poi_short_description": "Museum focusing on quarter horses, from cowboys to cutting competitions.",
      "poi_long_description": "People say this museum offers a fascinating look at the history of quarter horses, with engaging exhibits, statues, and a photo booth. They highlight the educational value, the beautiful and well-maintained building, and the fun, hands-on learning experience for kids and adults. They also like the welcoming staff and the convenient location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0e68-73eb-8521-7fe883007349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0e68-73eb-8521-7fe883007349",
        "storage_key": "property/6767906449165613/019cfb43-0e68-73eb-8521-7fe883007349.webp",
        "width": 850,
        "height": 417
      },
      "poi_business_url": "http://aqha.com/foundation",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295682578937935522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-quarter-horse-hall-of-fame--museum",
      "poi_latitude": "35.1942386",
      "poi_longitude": "-101.8079849",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-376-5181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ba3-7703-88c4-f7ff34e3af68",
        "storage_key": "property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbqJ1C9PAYcRovaZv6Z4P2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_67eea5d2-16e4-43bb-9c00-74f3cca524d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7701 I-40 700, Amarillo, TX 79121, USA",
      "poi_short_description": "Indoor trampoline park providing obstacle courses, a climbing wall, a zipline and more.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, a zipline, and obstacle courses, suitable for all ages. They highlight the fun and energetic vibe, and the affordable membership option. They also like the helpful, patient, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1028-7274-a5a9-735616ee3c4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1028-7274-a5a9-735616ee3c4c",
        "storage_key": "property/6767906449165613/019cfb43-1028-7274-a5a9-735616ee3c4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-amarillo/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17183422137472855803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.183417",
      "poi_longitude": "-101.9299011",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-310-9302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2NezVRRAYcR-y6ncWTHd-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_25a6d810-e396-419b-9a32-f27e027affe4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3801 Olsen Blvd, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean 24/7 gym featuring treadmills, plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym is clean and not overly crowded. They also highlight the friendly staff and the recent remodel.\n\nOther reviews mention the changing areas can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0f9c-7125-b096-e64b24206e9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0f9c-7125-b096-e64b24206e9e",
        "storage_key": "property/6767906449165613/019cfb43-0f9c-7125-b096-e64b24206e9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/amarillo-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1977894688478342336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.1847141",
      "poi_longitude": "-101.8828415",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-358-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaJ0MNpPAYcRwCziZb3kchs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ce136479-3ffe-47fc-9348-748f2110692e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Crunch Fitness - Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain fitness center offering group classes and personal training, plus tanning and a daycare.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including free weights, plate-loaded machines, and Olympic platforms, and has a functional training area with punching bags and sleds. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-105d-731d-86b2-1de8816599f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-105d-731d-86b2-1de8816599f4",
        "storage_key": "property/6767906449165613/019cfb43-105d-731d-86b2-1de8816599f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=5337674825006290011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---amarillo",
      "poi_latitude": "35.1919693",
      "poi_longitude": "-101.867029",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-0706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ429cxMlPAYcRW5QLH_k6E0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8a97ccd3-c426-4b8a-a313-6944c01768c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - I40/Bell St.",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Bell St, Amarillo, TX 79106, USA",
      "poi_short_description": "Gym chain featuring premium facilities such as basketball courts and saunas, plus personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, pin machines, plate-loaded machines, and functional equipment, as well as a sauna and basketball courts. They highlight the spacious layout, clean facilities, and friendly, helpful staff. They also like the positive and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-0ff1-77ff-ba93-f1f626c0771f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-0ff1-77ff-ba93-f1f626c0771f",
        "storage_key": "property/6767906449165613/019cfb43-0ff1-77ff-ba93-f1f626c0771f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/amarillo/hwy-40-bell-st/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17282652066854458207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---i40bell-st",
      "poi_latitude": "35.1889247",
      "poi_longitude": "-101.9037135",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-803-2302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUXZW6JRAYcRX9OHxXxQ2O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dacd65c4-20c1-441e-bca6-2f609edab27b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2814 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Large chain selling cosmetics, skincare and fragrance, plus hair salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-11e3-72de-b246-abd515b8e1a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-11e3-72de-b246-abd515b8e1a2",
        "storage_key": "property/6767906449165613/019cfb43-11e3-72de-b246-abd515b8e1a2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/amarillo-tx-278",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046894659973430930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.1814406",
      "poi_longitude": "-101.9399397",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-355-1176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRkj7syafi6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7bc600da-550a-471c-93b9-a90a6d974141",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo Town Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5801, 4514 Cornell St A, Amarillo, TX 79109, USA",
      "poi_short_description": "Health club offering a variety of equipment and classes, along with indoor and outdoor pools.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-11f5-73ac-8d0a-7add1f49ef92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-11f5-73ac-8d0a-7add1f49ef92",
        "storage_key": "property/6767906449165613/019cfb43-11f5-73ac-8d0a-7add1f49ef92.webp",
        "width": 1200,
        "height": 688
      },
      "poi_business_url": "https://amarillotownclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16997861687070698109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-town-club",
      "poi_latitude": "35.16022100000001",
      "poi_longitude": "-101.89843",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-468-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjT76sAVQAYcRfSoSVyWJ5Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e904a2bf-014d-4459-9fff-eb22c8e17a31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "P.E.T.S. Clinic of Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1246-7338-8f82-de458abfa03a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1246-7338-8f82-de458abfa03a",
        "storage_key": "property/6767906449165613/019cfb43-1246-7338-8f82-de458abfa03a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.petsclinic.org/locations/amarillo-texas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242055613026336119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pets-clinic-of-amarillo",
      "poi_latitude": "35.2117343",
      "poi_longitude": "-101.8647921",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-680-7049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyRWFUtPAYcRd_221f-qPBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_b46e5244-6331-4d18-863e-8ddfbd65f956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Bnails Amarillo ( Voted Best Nail Salon Amarillo TX)",
      "poi_type": "Health and Wellness",
      "poi_address": "5901 Coulter St S #200, Amarillo, TX 79119, USA",
      "poi_short_description": "Modern nail salon offering a variety of treatments including pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-124e-7409-ad8d-fba845b6182e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-124e-7409-ad8d-fba845b6182e",
        "storage_key": "property/6767906449165613/019cfb43-124e-7409-ad8d-fba845b6182e.webp",
        "width": 1050,
        "height": 1050
      },
      "poi_business_url": "https://bnails.com/locations/bnails-amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=2463208448936350150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bnails-amarillo--voted-best-nail-salon-amarillo-tx",
      "poi_latitude": "35.1476278",
      "poi_longitude": "-101.9194274",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-329-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbhOxQdbAYcRxpGXnggTLyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_710892fe-ad78-4b6d-bdaf-f97beefd3a6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "The Gym @ Contagion Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "8210 W Amarillo Blvd Suite A, Amarillo, TX 79124, USA",
      "poi_short_description": "Clean gym with modern equipment, turf, private rooms, a cafe, and friendly staff.",
      "poi_long_description": "Gym goers say this gym offers a wide variety of high-quality equipment, including power racks, deadlift platforms, and cable machines, as well as a cafe, a track, and a field. They also highlight the friendly and helpful staff, the clean facilities, and the supportive community atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1357-72db-aefd-e2036a5a3105.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1357-72db-aefd-e2036a5a3105",
        "storage_key": "property/6767906449165613/019cfb43-1357-72db-aefd-e2036a5a3105.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://contagionathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1028127880143985371&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-gym--contagion-athletics",
      "poi_latitude": "35.1921768",
      "poi_longitude": "-101.9283828",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-599-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVPdCchaAYcR21qoF9ykRA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_253e2434-da64-45d2-88c8-7194306395be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4514 First United Dr, Amarillo, TX 79119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1465-7746-a141-90dbb5dc8258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1465-7746-a141-90dbb5dc8258",
        "storage_key": "property/6767906449165613/019cfb43-1465-7746-a141-90dbb5dc8258.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/amarillo-texas-4451/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4451",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329623978590993559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.1605005",
      "poi_longitude": "-101.9368164",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-367-9842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwTg_UNRAYcRl_ztthHqFTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d9d3bf9e-b6cb-4da0-a9b4-27bd87893aa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Small Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "5127 Canyon Dr, Amarillo, TX 79110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.smallanimalec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3409723369463033888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "small-animal-emergency-clinic",
      "poi_latitude": "35.156026",
      "poi_longitude": "-101.877585",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-352-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQR8CU5FAYcRIDAxy1bFUS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_babae0f7-0d28-4632-a0c5-25227b2a98d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "BSA Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bsahs.org/find-a-provider/location/entity69860/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8155463932870903813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bsa-hospital",
      "poi_latitude": "35.1982302",
      "poi_longitude": "-101.9214119",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-212-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b98-770f-ad0a-1e170d96c3c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b98-770f-ad0a-1e170d96c3c6",
        "storage_key": "property/6767906449165613/019cfb43-1b98-770f-ad0a-1e170d96c3c6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-hXBuxRAYcRBchHyTwHLnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0098552e-271f-4ad8-99b0-5255c281e25f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Northwest Texas Healthcare System",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 Coulter St, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nwths.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075520162708353978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwest-texas-healthcare-system",
      "poi_latitude": "35.1998268",
      "poi_longitude": "-101.9201891",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-354-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b98-770f-ad0a-1e170d96c3c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b98-770f-ad0a-1e170d96c3c6",
        "storage_key": "property/6767906449165613/019cfb43-1b98-770f-ad0a-1e170d96c3c6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO08CY7FRAYcRunNkZpe6zRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_438490f5-cca6-4228-a868-461c1c48fa8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Small but well-maintained botanical garden featuring a Japanese area, a conservatory and a rose garden.",
      "poi_long_description": "People say this botanical garden offers a beautiful variety of plants, flowers, and themed gardens, including a butterfly garden, desert garden, rose garden, and Japanese garden. They highlight the peaceful and relaxing atmosphere, perfect for enjoying nature and taking photos, and the well-maintained grounds with easy-to-navigate walking paths. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-145a-708c-9d2e-8fe4c12227cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-145a-708c-9d2e-8fe4c12227cf",
        "storage_key": "property/6767906449165613/019cfb43-145a-708c-9d2e-8fe4c12227cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amarillobotanicalgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11051265959285629208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-botanical-gardens",
      "poi_latitude": "35.197691",
      "poi_longitude": "-101.915258",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-352-6513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYUtV7RRAYcRGCGWfdb7XZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cbafa7f6-3082-4d9a-bc2c-3cab498748ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "John Stiff Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 Bell St, Amarillo, TX 79109, USA",
      "poi_short_description": "Large open space, mainly for organized sports, featuring soccer and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-15b8-74de-a085-ea0b0e342cee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-15b8-74de-a085-ea0b0e342cee",
        "storage_key": "property/6767906449165613/019cfb43-15b8-74de-a085-ea0b0e342cee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amarilloparks.org/parks-facilities/parks/john-stiff-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14142316035318156834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-stiff-memorial-park",
      "poi_latitude": "35.1534565",
      "poi_longitude": "-101.9061596",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5FNyghQAYcRIg5zQoGZQ8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fa0db654-5b77-434c-abbf-ae99a6a53593",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Wildcat Bluff Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 N Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Preserve with miles of hiking trails and historical exhibits including a dig pit, plus picnic areas.",
      "poi_long_description": "People say this nature preserve offers beautiful hiking trails with diverse terrain and colorful wildflowers. They highlight the well-maintained trails, good parking, and the opportunity to experience nature. They also like the friendly staff and the large playground. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-15b8-74de-a085-e52ecf7e71a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-15b8-74de-a085-e52ecf7e71a4",
        "storage_key": "property/6767906449165613/019cfb43-15b8-74de-a085-e52ecf7e71a4.webp",
        "width": 1125,
        "height": 633
      },
      "poi_business_url": "http://wildcatbluff.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=ff955b2f-0847-4125-bf3c-98fd107de872",
      "poi_directions_map_url": "https://maps.google.com/?cid=1448519830726704444&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-bluff-nature-center",
      "poi_latitude": "35.2351151",
      "poi_longitude": "-101.9398872",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-352-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnY_PHH5RAYcRPP2SiBwtGhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d37514d-3ee0-4bce-8544-1d8054e8b4e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Comanche Trail Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4200 S Grand St, Amarillo, TX 79103, USA",
      "poi_short_description": "Golf course with a driving range offering affordable green fees.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1611-71cf-addb-183eb46f93a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1611-71cf-addb-183eb46f93a5",
        "storage_key": "property/6767906449165613/019cfb43-1611-71cf-addb-183eb46f93a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.playgolfamarillo.com/comanche-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=11481816463231899513&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "comanche-trail-golf-course",
      "poi_latitude": "35.1674039",
      "poi_longitude": "-101.7987703",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 806-378-4281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8e4dd1c1f0fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8e4dd1c1f0fb",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8e4dd1c1f0fb.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVVAHVNPAYcReVcrcz2bV58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ba32baeb-c10d-4d03-8608-9b96ab3fb342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Southeast Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 SE 46th Ave, Amarillo, TX 79118, USA",
      "poi_short_description": "Popular spot featuring a pond with a dock for fishing as well as a dog park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-160d-7108-aff6-ff8ea15b2855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-160d-7108-aff6-ff8ea15b2855",
        "storage_key": "property/6767906449165613/019cfb43-160d-7108-aff6-ff8ea15b2855.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://www.amarilloparks.org/parks-facilities/parks/southeast-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3216567373680786239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southeast-park",
      "poi_latitude": "35.1614672",
      "poi_longitude": "-101.8068651",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-e4e4fc9c1ca3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPfnBYvhFAYcRP7ta-PuKoyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7f9a2a9c-2e10-4a16-b8f9-ed99003b7343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Tradewind Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4105 Tradewind St, Amarillo, TX 79118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1665-7409-8d22-472dacab14ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1665-7409-8d22-472dacab14ee",
        "storage_key": "property/6767906449165613/019cfb43-1665-7409-8d22-472dacab14ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tradewindairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15990282243124226512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tradewind-airport",
      "poi_latitude": "35.168991",
      "poi_longitude": "-101.828453",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-376-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ea0-76bb-8608-968ad2544f2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ea0-76bb-8608-968ad2544f2e",
        "storage_key": "property/6767906449165613/019cfb43-1ea0-76bb-8608-968ad2544f2e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yXpyPFOAYcR0Omn3_rk6N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d5ce9182-e9d6-44a4-a739-e1d3944ce305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "623 S Johnson St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1725-77ac-b45f-7b89f30b0123.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1725-77ac-b45f-7b89f30b0123",
        "storage_key": "property/6767906449165613/019cfb43-1725-77ac-b45f-7b89f30b0123.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "https://www.amarillo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17223577524634485538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-city-hall",
      "poi_latitude": "35.2061862",
      "poi_longitude": "-101.8291358",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-378-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ea0-76bb-8608-9b6c0f56bf6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ea0-76bb-8608-9b6c0f56bf6a",
        "storage_key": "property/6767906449165613/019cfb43-1ea0-76bb-8608-9b6c0f56bf6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGW0sOONOAYcRIoM9FYFwBu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_e8d70978-0f24-4f1f-8af4-b4b7d983e557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Panhandle Eye Group Corporate Business Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7400 Fleming Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1736-702f-b549-6c2a4846a365.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-1736-702f-b549-6c2a4846a365",
        "storage_key": "property/6767906449165613/019cfb43-1736-702f-b549-6c2a4846a365.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.paneye.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6239967148491259387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-eye-group-corporate-business-office",
      "poi_latitude": "35.1935734",
      "poi_longitude": "-101.9237593",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-331-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcUlU61RAYcR-73tjw_RmFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c87449ee-1991-477b-8218-494e6e635fae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Toot'n Totum Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 S Taylor St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tootntotum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9938605481419247298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tootn-totum-corporate-office",
      "poi_latitude": "35.2019996",
      "poi_longitude": "-101.8364486",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-373-4351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWigFwJPAYcRwo6-QgcF7Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1e06886e-6272-4455-a088-36a34e2033d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Downtown Women's Center - Admin Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "409 S Monroe St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.dwcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17471674227271005040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-womens-center---admin-office",
      "poi_latitude": "35.2100297",
      "poi_longitude": "-101.8426996",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-372-3625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-D7mlVOAYcRcPPVCyTbd_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9f017e68-d262-46f6-9e0b-983471a82a5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Panhandle AIDS Support Organization",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 SW 10th Ave, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-17b6-734c-9e07-402719713b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb43-17b6-734c-9e07-402719713b1b",
        "storage_key": "property/6767906449165613/019cfb43-17b6-734c-9e07-402719713b1b.webp",
        "width": 1280,
        "height": 892
      },
      "poi_business_url": "http://panhandleaso.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7593567755602905026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-aids-support-organization",
      "poi_latitude": "35.2048277",
      "poi_longitude": "-101.8548318",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-372-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxRxZalPAYcRwkeSKqTFYWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_10611977-93c9-45ec-8abc-f9ecde820d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Hillside Elementary School",
      "poi_type": "Education",
      "poi_address": "9600 Perry Ave, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-abfc-74a9-aca5-24fa5fc64885.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-abfc-74a9-aca5-24fa5fc64885",
        "storage_key": "property/6767906449165613/019d7912-abfc-74a9-aca5-24fa5fc64885.webp",
        "width": 512,
        "height": 512
      },
      "poi_business_url": "http://hs.canyonisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1777101809080428046&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hillside-elementary-school",
      "poi_latitude": "35.13641399999999",
      "poi_longitude": "-101.949523",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-677-2520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7YxPw29aAYcRDmbxC66IqRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_37680e33-6f12-4b1b-bc3b-5f18e2623328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Ascension Academy",
      "poi_type": "Education",
      "poi_address": "9301 Ascension Pkwy, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-ab4f-750b-b165-e4d7b2989c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ab4f-750b-b165-e4d7b2989c37",
        "storage_key": "property/6767906449165613/019d7912-ab4f-750b-b165-e4d7b2989c37.webp",
        "width": 332,
        "height": 352
      },
      "poi_business_url": "http://www.ascensionacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12001972514699204040&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ascension-academy",
      "poi_latitude": "35.1575853",
      "poi_longitude": "-101.9461933",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-342-0515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdeF9CJBQAYcRyNWltmmSj6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e9ca3f79-de4e-44ed-9a0f-ce6ab01528bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Arden Road Elementary School",
      "poi_type": "Education",
      "poi_address": "6801 Learning Tree Ave, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-abf0-7185-9318-93c2aad27099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-abf0-7185-9318-93c2aad27099",
        "storage_key": "property/6767906449165613/019d7912-abf0-7185-9318-93c2aad27099.webp",
        "width": 1280,
        "height": 683
      },
      "poi_business_url": "http://ar.canyonisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5892351018120316462&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arden-road-elementary-school",
      "poi_latitude": "35.1293815",
      "poi_longitude": "-101.9146007",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-677-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbzoX1epaAYcRLgb5LgjWxVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f5fbf454-81a0-457e-aafe-c8d8d1d7ab8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "West Plains Junior High School",
      "poi_type": "Education",
      "poi_address": "7200 West Pkwy, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-abfd-756e-8ace-42b44d44c62b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-abfd-756e-8ace-42b44d44c62b",
        "storage_key": "property/6767906449165613/019d7912-abfd-756e-8ace-42b44d44c62b.webp",
        "width": 1280,
        "height": 683
      },
      "poi_business_url": "https://wpjh.canyonisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11033640805390694255&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-plains-junior-high-school",
      "poi_latitude": "35.1243367",
      "poi_longitude": "-101.9180813",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-677-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBc1hBOxaAYcRbzeRkNpdH5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1eba19cd-c112-467e-9152-e005506f67d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Greenways Intermediate School",
      "poi_type": "Education",
      "poi_address": "8100 Pineridge Drive, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-b33c-767e-92cf-b4f253b7aeea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b33c-767e-92cf-b4f253b7aeea",
        "storage_key": "property/6767906449165613/019d7912-b33c-767e-92cf-b4f253b7aeea.webp",
        "width": 1280,
        "height": 683
      },
      "poi_business_url": "https://gw.canyonisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4942415204457419532&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greenways-intermediate-school",
      "poi_latitude": "35.1452849",
      "poi_longitude": "-101.9309358",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-677-2460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4W1lPoFaAYcRDJMsQnH8lkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0766917b-44a8-4b7b-9ad2-c65c47ad4533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo High School",
      "poi_type": "Education",
      "poi_address": "4225 Danbury Dr, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-b45e-700d-bda7-edff97a6bcba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b45e-700d-bda7-edff97a6bcba",
        "storage_key": "property/6767906449165613/019d7912-b45e-700d-bda7-edff97a6bcba.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://ahs.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=752823074420987254&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-high-school",
      "poi_latitude": "35.16616339999999",
      "poi_longitude": "-101.9050351",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-326-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq4aKDhFQAYcRdpWU-ZiQcgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1ef197e4-3ab3-4cc4-85f7-4e6ad341e4fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo Collegiate Academy",
      "poi_type": "Education",
      "poi_address": "6000 S Georgia St, Amarillo, TX 79118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-b351-7368-b4c2-7014836048c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b351-7368-b4c2-7014836048c5",
        "storage_key": "property/6767906449165613/019d7912-b351-7368-b4c2-7014836048c5.webp",
        "width": 441,
        "height": 331
      },
      "poi_business_url": "https://questcollegiate.com/amarillo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263260898786172110&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-collegiate-academy",
      "poi_latitude": "35.1473",
      "poi_longitude": "-101.8671534",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-352-0171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzW3Gi2dFAYcRzlx6A4SRELg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f9bc17f8-113d-477f-9ca9-50a10dd7d252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Texas Tech University at Amarillo",
      "poi_type": "Education",
      "poi_address": "1400 Coulter St S, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ttuhsc.edu/campus/amarillo/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3594923258626868166&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-tech-university-at-amarillo",
      "poi_latitude": "35.2004197",
      "poi_longitude": "-101.9236083",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-414-9608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d73b702385a1",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d73b702385a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2VTQIa5RAYcRxoM-Mai74zE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_383ad95b-f871-43ea-b9c5-866e5b507ea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Public House",
      "poi_type": "Restaurants",
      "poi_address": "3333 Coulter St S, Amarillo, TX 79106, USA",
      "poi_short_description": "Stylish, modern American spot for elevated comfort food along with cocktails, wine & craft beer.",
      "poi_long_description": "People say this restaurant serves delicious meatloaf, prime rib soup, and wedge salad. They also highlight the inviting atmosphere, friendly and courteous service, and great drinks.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-b346-76ef-a99f-bb9a3d089f21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b346-76ef-a99f-bb9a3d089f21",
        "storage_key": "property/6767906449165613/019d7912-b346-76ef-a99f-bb9a3d089f21.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.publichouseamarillo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1105803344453180030&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "public-house",
      "poi_latitude": "35.1772076",
      "poi_longitude": "-101.9197562",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-398-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-IFd0RQAYcRfhqScUiaWA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3fa460db-50e0-4fb5-80f5-97d770876647",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Tokyo Japanese Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4000 S Soncy Rd, Amarillo, TX 79119, USA",
      "poi_short_description": "Chefs cook on hibachi grills at this bustling Japanese steakhouse with creative sushi rolls.",
      "poi_long_description": "People say this Japanese restaurant serves good sushi and hibachi. They also highlight the entertaining chefs and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-b9d4-76a8-bc00-cacb0abd85be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b9d4-76a8-bc00-cacb0abd85be",
        "storage_key": "property/6767906449165613/019d7912-b9d4-76a8-bc00-cacb0abd85be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9827822914628123357&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tokyo-japanese-steakhouse",
      "poi_latitude": "35.1653426",
      "poi_longitude": "-101.9387009",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-358-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-w3hwVQAYcR3Xra7d5wY4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_088045a1-95de-42f6-855e-32ba56d5163c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Metropolitan Steak & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "9181 Town Square Blvd Suite 1201, Amarillo, TX 79119, USA",
      "poi_short_description": "Stylish, fine dining stop serving chops, seafood & hearty sides alongside cocktails, wine & beer.",
      "poi_long_description": "Diners say this new American restaurant serves up delicious steak, brussel sprouts, and peppercorn au poivre. They also highlight the friendly, knowledgeable, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-c0e9-767a-827c-d0ce7ade2fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c0e9-767a-827c-d0ce7ade2fbd",
        "storage_key": "property/6767906449165613/019d7912-c0e9-767a-827c-d0ce7ade2fbd.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.metroofamarillo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1105535327362557129&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "metropolitan-steak-seafood",
      "poi_latitude": "35.14953819999999",
      "poi_longitude": "-101.9441569",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-242-0117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAwDwjoJQAYcRySQX2oWmVw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3bcbf10c-6805-4af9-a35a-28b1eef19acb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Home Plate Diner",
      "poi_type": "Restaurants",
      "poi_address": "5600 Bell St, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this diner serves delicious chicken fried steak, hamburgers, and green chile burgers. They also highlight the friendly service and cozy atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-bb94-742f-8e7c-f967c1e0f4a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bb94-742f-8e7c-f967c1e0f4a0",
        "storage_key": "property/6767906449165613/019d7912-bb94-742f-8e7c-f967c1e0f4a0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://homeplatedinertx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=824889353236887224&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "home-plate-diner",
      "poi_latitude": "35.1488006",
      "poi_longitude": "-101.9026076",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-359-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0njW6ZaAYcRuLavDn-Ycgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_3e85fcca-2f98-48c1-838a-85cf422de1ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Cafe Marizon",
      "poi_type": "Restaurants",
      "poi_address": "6151 Hillside Rd, Amarillo, TX 79109, USA",
      "poi_short_description": "American fare in a spacious dining room lined with local historical photos, plus an outdoor patio.",
      "poi_long_description": "People say this restaurant serves delicious, home-style American comfort food, including roast beef, chicken fried chicken, and hamburger steak. They highlight the fair prices, casual and nostalgic vibe, and the friendly and attentive staff. They also like the homemade bread and ranch dressing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-bc2a-77bb-9bc6-529b30e4acaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bc2a-77bb-9bc6-529b30e4acaf",
        "storage_key": "property/6767906449165613/019d7912-bc2a-77bb-9bc6-529b30e4acaf.webp",
        "width": 1280,
        "height": 734
      },
      "poi_business_url": "https://www.cafemarizon.com/menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=5753728732827268520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cafe-marizon",
      "poi_latitude": "35.1462424",
      "poi_longitude": "-101.9042858",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-352-2046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVwoFvxOAYcRqLUgRsxZ2U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5e85b296-d37d-4c1a-894d-85e247f7627f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Buns Over Texas",
      "poi_type": "Restaurants",
      "poi_address": "6045 SW 34th Ave, Amarillo, TX 79109, USA",
      "poi_short_description": "Mainstay for burgers & American grub, plus lots of iced tea, in a chill space lined with road signs.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious burgers, onion rings, and sweet potato fries, with a great selection of teas. They also highlight the friendly staff and the efficient service.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-c4e9-738c-8e74-14670b1edc76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c4e9-738c-8e74-14670b1edc76",
        "storage_key": "property/6767906449165613/019d7912-c4e9-738c-8e74-14670b1edc76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bunsovertexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2993159810304644280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buns-over-texas",
      "poi_latitude": "35.175915",
      "poi_longitude": "-101.903796",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-358-6808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRv_Dz1QAYcRuBQvMf3WiSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_589a4de3-a36a-4ed3-a0eb-6b2760e02a90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Teddy Jack's Armadillo Grill",
      "poi_type": "Restaurants",
      "poi_address": "5080 Coulter St S, Amarillo, TX 79119, USA",
      "poi_short_description": "Family-friendly grill serving burgers and Tex-Mex fare, along with beer and cocktails.",
      "poi_long_description": "People say this restaurant offers a wide variety of dishes, including pizza, salads, and burgers. They also highlight the great service and friendly staff.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-c66f-72f4-849b-9c9e13015faf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c66f-72f4-849b-9c9e13015faf",
        "storage_key": "property/6767906449165613/019d7912-c66f-72f4-849b-9c9e13015faf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://teddyjacks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5472714489992181899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "teddy-jack-s-armadillo-grill",
      "poi_latitude": "35.1540453",
      "poi_longitude": "-101.9207991",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-322-0113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1b9c-7193-b3d7-eaa2b8a40527",
        "storage_key": "property/6767906449165613/019cfb43-1b9c-7193-b3d7-eaa2b8a40527.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYW9a-XZQAYcRi_gdPdX88ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b7508d9f-2092-4c25-8ce2-afad4c330af5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "The Summit Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "SW 34th Ave, Amarillo, TX 79121, USA",
      "poi_short_description": "Shopping center featuring Ed's Meats and other retailers, plus dining options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-c5de-72d6-9763-4b48d27f73ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c5de-72d6-9763-4b48d27f73ce",
        "storage_key": "property/6767906449165613/019d7912-c5de-72d6-9763-4b48d27f73ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/4k9FWaY",
      "poi_directions_map_url": "https://maps.google.com/?cid=5401818715517553842&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-summit-shopping-center",
      "poi_latitude": "35.1775112",
      "poi_longitude": "-101.9222964",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXYvQslxQAYcRsgx7b4Ad90o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cf80a7f4-05a9-4066-8271-4b9efebca936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "The Shops@34th",
      "poi_type": "Shopping & Retail",
      "poi_address": "3405 S Western St, Amarillo, TX 79109, USA",
      "poi_short_description": "Shopping center with a variety of stores including apparel, plus food options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-cfc8-76b8-87bc-946f0129399b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cfc8-76b8-87bc-946f0129399b",
        "storage_key": "property/6767906449165613/019d7912-cfc8-76b8-87bc-946f0129399b.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17044601624685572&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-shops-34th",
      "poi_latitude": "35.1775593",
      "poi_longitude": "-101.8832259",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7wTC3t1PAYcRBGwtkfmNPAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_13cee95a-40bb-4f0f-b39b-b4faccfa69c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "De De's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3424 S Western St, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18127589227795977641&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "de-de-s",
      "poi_latitude": "35.1745592",
      "poi_longitude": "-101.8843643",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-356-6208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_9kvtuBPAYcRqRX6zFsikvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_9ba581d9-36ad-440b-88b6-4a12ab7aa5ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4610 Coulter St S, Amarillo, TX 79119, USA",
      "poi_short_description": "Chain retailer offering merchandise ranging from groceries and clothes to toys, electronics, and home goods.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, hardware, garden supplies, and pharmacy items. They also highlight the clean and organized store, and the helpful and friendly staff.\n\nOther reviews mention the checkout process can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-d07b-70a9-813d-0d9f60635eee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d07b-70a9-813d-0d9f60635eee",
        "storage_key": "property/6767906449165613/019d7912-d07b-70a9-813d-0d9f60635eee.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/755-amarillo-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12853371533483037218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.1596727",
      "poi_longitude": "-101.9234837",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-354-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX3pVsXFQAYcRItJfQ09ZYLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_de22b6a2-2e33-4e31-a225-a7a9153a642b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8201 I-40 W, Amarillo, TX 79121, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of items, including seasonal items, gifts, and household goods, at great prices. They also highlight the friendly and helpful staff, and many appreciate the convenient curbside pickup service.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-da86-768b-8bd4-8f99baa6006d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-da86-768b-8bd4-8f99baa6006d",
        "storage_key": "property/6767906449165613/019d7912-da86-768b-8bd4-8f99baa6006d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/amarillo/221",
      "poi_directions_map_url": "https://maps.google.com/?cid=2462063419515012103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.1859504",
      "poi_longitude": "-101.934272",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ5MuplBQAYcRBwStrqIBKyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_aac4c030-acc4-4950-b146-a1def57eafef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Garden Center at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-da58-77e8-aab3-f8a806738aa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-da58-77e8-aab3-f8a806738aa6",
        "storage_key": "property/6767906449165613/019d7912-da58-77e8-aab3-f8a806738aa6.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://www.homedepot.com/l/Amarillo/TX/Amarillo/79124/6552/garden-center?emt=GCGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13629880136841492292&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garden-center-at-the-home-depot",
      "poi_latitude": "35.1851972",
      "poi_longitude": "-101.9398995",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-355-3895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdynAXPlQAYcRRPeWL8UPJ70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_71789a10-4f29-4e50-88a5-b8ab2f351704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Coulter St, Amarillo, TX 79119, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of lumber, hardware, and tools. They also highlight the helpful and friendly employees, and the fast and easy pickup service.\n\nOther reviews mention the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-db9b-72af-826b-0936da4a9f8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-db9b-72af-826b-0936da4a9f8d",
        "storage_key": "property/6767906449165613/019d7912-db9b-72af-826b-0936da4a9f8d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Amarillo/0270?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-270-_-na-_-0-_-0&y_source=1_MTE4NDA5My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11373186961149334328&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "35.1573635",
      "poi_longitude": "-101.92293",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-353-2003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1bae-7065-a26b-d98752b59d3a",
        "storage_key": "property/6767906449165613/019cfb43-1bae-7065-a26b-d98752b59d3a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9z4bmHBQAYcROBNpj0it1Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fc0e3762-680f-4434-9c83-dca5af9dbb76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2200 S Van Buren St, Amarillo, TX 79109, USA",
      "poi_short_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_long_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-e0e4-710a-87fb-f439df334d41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e0e4-710a-87fb-f439df334d41",
        "storage_key": "property/6767906449165613/019d7912-e0e4-710a-87fb-f439df334d41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amoa.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=216dd4bc-81fb-4580-9828-ab80d0de8de8",
      "poi_directions_map_url": "https://maps.google.com/?cid=15566548492245588692&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-museum-of-art",
      "poi_latitude": "35.1885361",
      "poi_longitude": "-101.8451167",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-371-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ba3-7703-88c4-f7ff34e3af68",
        "storage_key": "property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ehFk6dPAYcR1Now62B9B9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_856768da-6dc8-4e1e-94b2-c5334df5e30e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Kwahadi Museum of the American Indian",
      "poi_type": "Entertainment",
      "poi_address": "9151 I-40, Amarillo, TX 79118, USA",
      "poi_short_description": "Heritage museum with exhibits on Native American culture & art, plus traditional dance performances.",
      "poi_long_description": "Heritage museum with exhibits on Native American culture & art, plus traditional dance performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-e733-74ce-b1b0-74089fa21e70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e733-74ce-b1b0-74089fa21e70",
        "storage_key": "property/6767906449165613/019d7912-e733-74ce-b1b0-74089fa21e70.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kwahadi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17281962955541415008&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kwahadi-museum-of-the-american-indian",
      "poi_latitude": "35.1937799",
      "poi_longitude": "-101.7340188",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 806-335-3175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1ba3-7703-88c4-f7ff34e3af68",
        "storage_key": "property/6767906449165613/019cfb43-1ba3-7703-88c4-f7ff34e3af68.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn43ic0FIAYcRYISBir7d1e8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1466928b-8255-47ba-8a08-c8001fc234b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Wonderland Amusement Park",
      "poi_type": "Entertainment",
      "poi_address": "2601 Dumas Dr, Amarillo, TX 79107, USA",
      "poi_short_description": "Roller coasters, carousel, water & kiddie rides (some nostalgic), plus an arcade & more, since 1951.",
      "poi_long_description": "People say this amusement park offers a variety of rides and attractions, including classic coasters and flat rides, and is a fun place to spend time with family. They also highlight the friendly and helpful staff, and the nostalgic, old-school vibe.\n\nOther reviews mention some rides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-e968-75c9-972e-fb24204e47d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e968-75c9-972e-fb24204e47d9",
        "storage_key": "property/6767906449165613/019d7912-e968-75c9-972e-fb24204e47d9.webp",
        "width": 1280,
        "height": 614
      },
      "poi_business_url": "http://www.wonderlandpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8243954437591312918&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wonderland-amusement-park",
      "poi_latitude": "35.2407215",
      "poi_longitude": "-101.8321242",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 806-383-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfEzUZtOAYcRFqoi9eFoaHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_f299b39d-3e4e-4db5-876c-e3497f3d9f21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo Zoo",
      "poi_type": "Entertainment",
      "poi_address": "700 Comanchero Trail, Amarillo, TX 79107, USA",
      "poi_short_description": "Bison & big cats, reptiles, birds & amphibians all can be found in this compact park.",
      "poi_long_description": "People say this zoo offers a variety of animals, including exotic creatures, and is a fun and affordable experience for families.\n\nOther reviews mention the facilities can be neglected and some enclosures can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-f3bb-755b-b925-e9bb0cfd23e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f3bb-755b-b925-e9bb0cfd23e3",
        "storage_key": "property/6767906449165613/019d7912-f3bb-755b-b925-e9bb0cfd23e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://zoo.amarillo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7520201244900869847&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-zoo",
      "poi_latitude": "35.2394971",
      "poi_longitude": "-101.8352622",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 806-381-7911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-PYbYVOAYcR10bEQTAfXWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_20db590f-d943-43e2-8125-f1b874696bae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "poi_name": "Amarillo Route 66",
      "poi_type": "Entertainment",
      "poi_address": "3511 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019d7912-f6ff-76ff-bfdd-dab685cff997.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f6ff-76ff-bfdd-dab685cff997",
        "storage_key": "property/6767906449165613/019d7912-f6ff-76ff-bfdd-dab685cff997.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amarillo66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13277623560839957059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-route-66",
      "poi_latitude": "35.2110614",
      "poi_longitude": "-101.876196",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-373-1427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb43-1baf-750c-b020-8a6603c2ac35",
        "storage_key": "property/6767906449165613/019cfb43-1baf-750c-b020-8a6603c2ac35.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYBQ6DpOAYcRQwo53UeYQ7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fec4684f3da2518aa3914c1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_dac66cc78919112f38aff510",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4ed696b94b6566a965cabc25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_926c11502694e7e4d682e7a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_fbe04c73dbb9e10d1c68e5f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_5a66cb264c8c854a87c2dc0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_89a57692-4580-49ec-88af-c91cb57d639d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "rating": "5.0",
      "name": "Luz Arriola",
      "text": "The staff and maintenance people took care of my problems in the apartment quickly.  The guy who came to fix things was courteous and explained the problem to me.",
      "date": "2025-09-17",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_fc91fdbb-bbe4-4947-896b-8201030e1267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-c80f-711a-a2e7-3530e2877724.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of community pool and deck area with seating and umbrellas.",
        "public_id": "019cfb43-c80f-711a-a2e7-3530e2877724",
        "storage_key": "property/6767906449165613/019cfb43-c80f-711a-a2e7-3530e2877724.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Newport Amarillo Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=63187cafdd09724abb7ef90c&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-4688-72b9-ae32-a9534b874a39",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "newport-amarillo-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613"
    },
    {
      "lead_collector_id": "019cf79e-46fa-774f-8f5c-a2032686bd57",
      "lead_source": "LANDING_PAGE",
      "name": "newport-amarillo-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apts-amarillo-tx",
      "search_query": "apartments with in-unit laundry in Amarillo TX",
      "category": "Amenity",
      "h1_title": "Apartments with In-unit Laundry",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Newport Amarillo Apts. Enjoy a hassle-free lifestyle in Amarillo, TX, with modern amenities just for you.",
      "page_copy": "Experience the epitome of convenience at Newport Amarillo Apts, where select units boast in-unit laundry facilities, a rare find in Amarillo, TX. Imagine the ease of doing laundry right in the comfort of your own home, freeing up more time to enjoy the community’s array of amenities like the sparkling pool and the vibrant dog park. \n\nOur community is dedicated to providing residents with a seamless living experience. In addition to in-unit laundry, units feature walk-in closets and private patios, ensuring every comfort is at your fingertips. Visit Newport Amarillo Apts today and see how we transform apartment living with our exceptional offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-unit Laundry at Amarillo Apartments",
      "seo_description": "Explore Newport Amarillo Apts. Enjoy select apartments with in-unit laundry alongside modern amenities in vibrant Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "pet-friendly-dog-park-apts-amarillo",
      "search_query": "pet-friendly apartments with dog park Amarillo",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Enjoy pet-friendly living at Newport Amarillo Apts in Amarillo. Our dog park makes it perfect for you and your furry friend.",
      "page_copy": "Welcome to Newport Amarillo Apts, where pet-friendly living is taken to the next level. Nestled in the heart of Amarillo, TX, our community offers spacious one and two-bedroom apartments that warmly welcome pets. Our on-site dog park ensures that furry residents have plenty of room to play and socialize, making every day an adventure.\n\nOur thoughtfully designed apartments not only cater to your pets but also offer amenities that elevate your lifestyle. From walk-in closets and private patios to a stunning courtyard and extra storage space, Newport Amarillo Apts has it all. Come visit us and discover why our pet-friendly community is the perfect place for both you and your four-legged companions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo Pet-Friendly Apts with Dog Park",
      "seo_description": "Discover Newport Amarillo Apts. Pet-friendly living in Amarillo with a dedicated dog park, perfect for you and your pet's active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "luxury-pool-apartments-amarillo-tx",
      "search_query": "luxury apartments with a pool in Amarillo TX",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Amarillo",
      "h2_subtitle": "Newport Amarillo Apts offers luxurious living in Amarillo, TX. Dive into relaxation with our exquisite pool and top-notch amenities.",
      "page_copy": "Experience the pinnacle of luxury at Newport Amarillo Apts, where lifestyle meets elegance in Amarillo, TX. Our stunning pool area offers a serene escape from the bustling city, allowing residents to unwind in style. Whether you're soaking up the sun or going for a refreshing dive, our pool is the perfect place to relax and rejuvenate.\n\nAt Newport Amarillo Apts, luxury doesn't end at the poolside. Our beautifully designed apartments feature walk-in closets, private patios, and are cable-ready, ensuring every detail matches your upscale lifestyle. Visit our exceptional community and see why our amenities make every day feel like a vacation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo Luxury Apts with Pool",
      "seo_description": "Indulge in luxury living at Newport Amarillo Apts. Enjoy a beautiful pool and upscale amenities in the heart of Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "amarillo-apts-dishwasher-air-conditioning",
      "search_query": "Amarillo apartments with dishwasher and air conditioning",
      "category": "Amenity",
      "h1_title": "Amarillo Apartments with Dishwasher & A/C",
      "h2_subtitle": "Discover comfort at Newport Amarillo Apts with dishwashers and air conditioning in every unit. Enjoy modern living in Amarillo.",
      "page_copy": "At Newport Amarillo Apts, we understand the importance of modern conveniences to enhance your living experience. Located in the vibrant city of Amarillo, TX, our apartments feature essential amenities like dishwashers and air conditioning, ensuring comfort and convenience at every turn. Say goodbye to heat waves with efficient air conditioning and enjoy more time for yourself with a built-in dishwasher in each unit.\n\nOur community is designed to cater to your lifestyle with generous floor plans offering walk-in closets, private patios, and ample storage space. With a focus on providing superior living, Newport Amarillo Apts ensures that your home is a place of relaxation and ease. Visit us today to explore why our apartments are the perfect choice for contemporary living in Amarillo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo Apts with Dishwasher & A/C",
      "seo_description": "Find comfort at Newport Amarillo Apts, featuring dishwashers and air conditioning. Enjoy modern amenities in the heart of Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "modern-apts-near-79109-walk-in-closets",
      "search_query": "modern apartments near 79109 with walk-in closets",
      "category": "Amenity",
      "h1_title": "Modern Apartments Near 79109 with Walk-In Closets",
      "h2_subtitle": "Discover Newport Amarillo Apts, offering modern living near 79109 with spacious walk-in closets tailored for your comfort.",
      "page_copy": "Welcome to Newport Amarillo Apts, where modern meets convenience just minutes away from the 79109 area. Our stylish one and two-bedroom apartments are thoughtfully designed with roomy walk-in closets to accommodate all your storage needs. Whether it's fashion or functionality, you'll appreciate the ample space these closets provide.\n\nPositioned in a bustling neighborhood in Amarillo, TX, our modern apartments offer more than just spacious closets. Enjoy the serenity of our beautifully landscaped courtyard or relax on your private patio. With additional top-tier amenities such as cable readiness and extra storage, Newport Amarillo Apts combines comfort with contemporary living. Come experience why our community feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apts Near 79109 with Walk-In Closets",
      "seo_description": "Live stylishly at Newport Amarillo Apts near 79109. Modern apartments with spacious walk-in closets offer comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-amarillo-tx",
      "search_query": "one bedroom apartments amarillo tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Amarillo, TX",
      "h2_subtitle": "Explore our spacious one bedroom apartments at Newport Amarillo Apts. Discover comfort and style in the heart of Amarillo, TX.",
      "page_copy": "If you're searching for a cozy and contemporary one bedroom apartment in Amarillo, TX, look no further than Newport Amarillo Apts. Our one bedroom layouts are designed to provide the perfect balance of comfort and style, offering generous space complemented by high-quality finishes. Each unit is cable-ready and features private patios, enhancing your living experience.\n\nNestled in a lively Amarillo neighborhood, our community boasts a variety of amenities tailored to meet your needs. With features like walk-in closets and extra storage, you'll find ample room for all your belongings. Plus, enjoy the gorgeous courtyard and an on-site dog park. Discover why Newport Amarillo Apts is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Amarillo, TX",
      "seo_description": "Find the perfect one bedroom apartment at Newport Amarillo Apts. Enjoy spacious layouts and modern amenities in the heart of Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-sw-45th-ave-amarillo",
      "search_query": "two bedroom floor plans near sw 45th ave amarillo",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans Near SW 45th Ave",
      "h2_subtitle": "Discover our spacious two bedroom floor plans at Newport Amarillo Apts, conveniently located near SW 45th Ave in Amarillo.",
      "page_copy": "Welcome to Newport Amarillo Apts, where our thoughtfully designed two bedroom floor plans offer an ideal living experience near SW 45th Ave in Amarillo, TX. Tailored for both style and practicality, these floor plans provide ample space and comfort, perfect for various lifestyles. Each unit features walk-in closets, ensuring you have plenty of room for your essentials.\n\nSituated in a vibrant part of Amarillo, our community offers easy access to local amenities and entertainment options. Enjoy spending your days relaxing in our courtyard or at the pool, knowing you’re just moments away from everything SW 45th Ave has to offer. Newport Amarillo Apts invites you to explore why our two bedroom floor plans are perfect for a comfortable, convenient lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans Near SW 45th Ave",
      "seo_description": "Explore spacious two bedroom floor plans at Newport Amarillo Apts, near SW 45th Ave, Amarillo. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-college-tx",
      "search_query": "apartments near Amarillo College TX",
      "category": "School",
      "h1_title": "Apartments Near Amarillo College, TX",
      "h2_subtitle": "Discover the convenience of living at Newport Amarillo Apts, located near Amarillo College, TX.",
      "page_copy": "For those seeking convenient living near Amarillo College, TX, Newport Amarillo Apts is the perfect choice. Our one and two-bedroom apartments offer a blend of comfort and style, making them ideal for students and faculty alike. With amenities like private patios and walk-in closets, you'll appreciate the thoughtful details designed to enhance your lifestyle.\n\nSituated in vibrant Amarillo, our community places you just minutes from Amarillo College, providing easy access to campus life and educational opportunities. Relax by the pool after a busy day or take your furry friend to our on-site dog park. Newport Amarillo Apts offers the perfect balance of tranquility and proximity, ensuring you’re never too far from what matters most.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo College, TX",
      "seo_description": "Live conveniently at Newport Amarillo Apts, close to Amarillo College, TX. Enjoy modern amenities and comfortable living near campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "newport-amarillo-apts-close-to-amarillo-college-west-campus",
      "search_query": "Newport Amarillo apts close to Amarillo College West Campus",
      "category": "School",
      "h1_title": "Newport Amarillo Apts Near Amarillo College West",
      "h2_subtitle": "Experience the convenience of living at Newport Amarillo Apts, close to Amarillo College West Campus, and enjoy a perfect blend of comfort and location.",
      "page_copy": "Nestled in Amarillo, Newport Amarillo Apts offers the ideal location for those attending or working at Amarillo College West Campus. Our apartments provide easy access to the educational opportunities and vibrant campus life, making your daily commute effortless. Choose from our spacious one and two-bedroom floor plans, designed with features like walk-in closets and private patios.\n\nLiving at Newport Amarillo Apts means more than just proximity to Amarillo College West Campus. You'll enjoy a vibrant community featuring a pool for relaxation, a courtyard for social connections, and an on-site dog park for your furry companions. Our dedicated on-site team ensures that your needs are always met, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Newport Amarillo Apts Near Amarillo College West",
      "seo_description": "Find your home at Newport Amarillo Apts, just a short distance from Amarillo College West Campus. Enjoy convenience and comfort in vibrant Amarillo.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "apartments-near-bsa-hospital-amarillo-tx",
      "search_query": "apartments near BSA Hospital Amarillo TX",
      "category": "Hospital",
      "h1_title": "Apartments Near BSA Hospital Amarillo, TX",
      "h2_subtitle": "Explore the convenience of Newport Amarillo Apts, located near BSA Hospital in Amarillo, TX.",
      "page_copy": "For those working at or visiting BSA Hospital in Amarillo, TX, Newport Amarillo Apts offers an ideal living solution just moments away. Our one and two-bedroom apartments are designed to provide both comfort and convenience, making it easy to maintain a work-life balance in this vibrant city. Enjoy features like walk-in closets and cable-ready setups that enhance your living experience.\n\nLocated in a prime area of Amarillo, Newport Amarillo Apts not only offers proximity to BSA Hospital but also provides a wealth of amenities to complement your lifestyle. Relax in the beautifully landscaped courtyard, take a refreshing dip in the pool, or unwind on your private patio after a long day. With a committed on-site management team, you'll find the perfect blend of tranquility and community right here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near BSA Hospital Amarillo, TX",
      "seo_description": "Discover Newport Amarillo Apts, ideally located near BSA Hospital in Amarillo, TX. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "amarillo-apartments-close-to-northwest-texas-healthcare",
      "search_query": "Amarillo apartments close to Northwest Texas Healthcare",
      "category": "Hospital",
      "h1_title": "Amarillo Apts Close to NW Texas Healthcare",
      "h2_subtitle": "Discover Newport Amarillo Apts, just minutes from Northwest Texas Healthcare. Enjoy convenience and comfort in a prime location.",
      "page_copy": "Newport Amarillo Apts is the perfect choice for those seeking an apartment close to Northwest Texas Healthcare in Amarillo. Our community offers a range of one and two-bedroom floor plans that are ideal for healthcare professionals or anyone looking for quick access to the hospital. Features like spacious walk-in closets and cable-ready units add extra comfort to your living experience.\n\nLocated in a vibrant Amarillo neighborhood, Newport Amarillo Apts provides more than just proximity to Northwest Texas Healthcare. Residents can enjoy a refreshing pool, a serene courtyard, and on-site storage spaces, ensuring your lifestyle needs are fully met. Our dedicated team ensures top-notch service, making it easy for you to feel right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo Apts Close to NW Texas Healthcare",
      "seo_description": "Live near Northwest Texas Healthcare at Newport Amarillo Apts. Enjoy modern amenities and prime location in Amarillo.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-botanical-gardens",
      "search_query": "apartments near amarillo botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Amarillo Botanical Gardens",
      "h2_subtitle": "Discover the charm of Newport Amarillo Apts, ideally situated near Amarillo Botanical Gardens. Embrace nature's beauty with convenience.",
      "page_copy": "Located just a short distance from the picturesque Amarillo Botanical Gardens, Newport Amarillo Apts offers a serene living experience in a vibrant community. Our one and two-bedroom apartments are perfect for nature enthusiasts who appreciate the tranquility and beauty of lush gardens. With easy access to the botanical gardens, residents can enjoy peaceful walks and inspiring views whenever they desire.\n\nNewport Amarillo Apts is more than just a great location near Amarillo Botanical Gardens. Our apartment community comes complete with a range of amenities, including a sparkling pool, walk-in closets for ample storage, and private patios for relaxation. Our friendly on-site team is dedicated to providing exceptional service, ensuring you have everything you need for a comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo Botanical Gardens",
      "seo_description": "Find your perfect home at Newport Amarillo Apts, close to Amarillo Botanical Gardens. Enjoy amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "rentals-close-to-john-stiff-memorial-park-amarillo",
      "search_query": "rentals close to john stiff memorial park amarillo",
      "category": "Park",
      "h1_title": "Rentals Near John Stiff Memorial Park",
      "h2_subtitle": "Experience the convenience of living near John Stiff Memorial Park at Newport Amarillo Apts. Enjoy a vibrant neighborhood with lush greenery nearby.",
      "page_copy": "Nestled close to the scenic John Stiff Memorial Park in Amarillo, Newport Amarillo Apts offers a fantastic home base for those who love outdoor activities. Our one and two-bedroom rentals provide the perfect blend of comfort and location, with easy access to the park's walking trails and recreational facilities, making weekend outings a breeze.\n\nThe proximity to John Stiff Memorial Park is just one of the many benefits of living at Newport Amarillo Apts. Our community features outstanding amenities such as a welcoming courtyard, ample storage spaces, and private patios ideal for lounging in the sun. The dedicated on-site team at Newport Amarillo Apts ensures that all residents enjoy a seamless living experience in this vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near John Stiff Memorial Park",
      "seo_description": "Discover Newport Amarillo Apts, located near John Stiff Memorial Park in Amarillo. Enjoy comfort and nature with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "living-near-wildcat-bluff-nature-center-amarillo",
      "search_query": "living near wildcat bluff nature center amarillo",
      "category": "Park",
      "h1_title": "Live Near Wildcat Bluff Nature Center",
      "h2_subtitle": "Explore life at Newport Amarillo Apts, located close to Wildcat Bluff Nature Center. Enjoy nature and comfort in one beautiful setting.",
      "page_copy": "Experience the best of both worlds by living near Wildcat Bluff Nature Center at Newport Amarillo Apts in Amarillo. Our community is ideal for nature lovers who enjoy hiking and outdoor activities, offering quick access to the nature trails and scenic views at Wildcat Bluff. Choose from our thoughtfully designed one and two-bedroom apartments that offer comfort and convenience.\n\nNewport Amarillo Apts is more than just a location; it’s a community that embraces a natural lifestyle while providing top-notch amenities. Walk-in closets, pet-friendly parks, and cable-ready units are just a few of the features that enhance your living experience. Our dedicated on-site team ensures every resident feels at home while enjoying the nature-focused environment around them.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Wildcat Bluff Nature Center",
      "seo_description": "Discover Newport Amarillo Apts, close to Wildcat Bluff Nature Center. Embrace nature and enjoy modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165613",
      "source": "generator",
      "page_item_url": "apartments-by-southeast-park-amarillo-tx",
      "search_query": "apartments by southeast park amarillo tx",
      "category": "Park",
      "h1_title": "Apartments by Southeast Park in Amarillo",
      "h2_subtitle": "Discover the convenience of living by Southeast Park at Newport Amarillo Apts. Enjoy the perfect balance of nature and city life.",
      "page_copy": "Positioned nearby the family-friendly Southeast Park, Newport Amarillo Apts offers an appealing living option for those who seek both tranquility and activity in Amarillo, TX. Our one and two-bedroom apartments are just a short walk from the park, making it easy to enjoy its playgrounds, sport courts, and picnic areas.\n\nAt Newport Amarillo Apts, we provide more than just a convenient location to Southeast Park. Enjoy community features like welcoming courtyards, spacious storage options, and inviting patios that enhance your everyday life. Our attentive on-site team is committed to making your living experience smooth and enjoyable, so you can focus on the things you love both in the community and beyond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
      "featured_image_media": {
        "alt_text": "Newport Apartment Homes monument sign",
        "public_id": "019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7",
        "storage_key": "property/6767906449165613/019cfb42-fa9f-75e4-9a7f-6af5ef6bcda7.webp",
        "width": 2048,
        "height": 1364
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Southeast Park, Amarillo",
      "seo_description": "Live at Newport Amarillo Apts, adjacent to Southeast Park in Amarillo, TX. Enjoy spacious layouts and top amenities near green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5188"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-B1GTYDC0VV"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151379"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/newport-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M5SVS6K5"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165613/019d1bd8-dad8-70d9-a12d-65bc75e83a7b.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "830adc3a-9116-43e2-ace6-5d371c6cb89c"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-662-0971"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af75c6dcba1e10ea6ad6"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1yNWZpVzhyOHIvbk01ZlJadGZwS2c9PSIsInZhbHVlIjoiZWNraXBvQTJEVTJUbTFnN1F2c2FjUT09IiwibWFjIjoiZWQ0M2Y0MDcyODI5MWU4Mzk0M2E0MmU0OGRiNjFjMGM3OTNlZTEyZDNhMjA0NTNjYzczZDg0ODM3OWJmNmEzMyJ9"
    }
  ],
  "custom_qb_id": "5188",
  "custom_ga4_id": "G-B1GTYDC0VV",
  "custom_repli_id": "10041151379",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/newport-apartments/register/",
  "custom_google_gtm_id": "GTM-M5SVS6K5",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165613/019d1bd8-dad8-70d9-a12d-65bc75e83a7b.pdf",
  "custom_rentgrata_property_id": "830adc3a-9116-43e2-ace6-5d371c6cb89c",
  "custom_ppc_tracking_phone_number": "844-662-0971",
  "custom_residentboost_apartment_id": "6504af75c6dcba1e10ea6ad6",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1yNWZpVzhyOHIvbk01ZlJadGZwS2c9PSIsInZhbHVlIjoiZWNraXBvQTJEVTJUbTFnN1F2c2FjUT09IiwibWFjIjoiZWQ0M2Y0MDcyODI5MWU4Mzk0M2E0MmU0OGRiNjFjMGM3OTNlZTEyZDNhMjA0NTNjYzczZDg0ODM3OWJmNmEzMyJ9"
};

export const generatedAt = '2026-08-27T21:37:40.228Z';
